<template>
  <v-container fluid>
    <v-card flat class="rounded-lg pa-2" height="100%">
      <div class="rounded-lg pageTitle" style="width: 100%;">
        <v-toolbar-title style="font-weight:bold;">標的物設備管理</v-toolbar-title>
      </div>
      <div class="rowDiv contentCenter mt-1">
        <div class="pa-1 ml-2 font-weight-black text-h5">管制區：</div>
        <div class="pa-0"
          v-for="item in areaListFilter"
          v-bind:key="item.area_id"
        >
          <v-checkbox 
            dense
            hide-details
            v-model="area_checked"
            :label="item.area_nm"
            :value="item.area_id"
            @click="tryGetRealTimeAlertPageData"
            v-show="item.area_id.indexOf('DUMMY') !== 0"
            class="mr-5 pt-0 mt-0"
          ></v-checkbox>
        </div>
        <v-spacer>
        </v-spacer>
      </div>
    </v-card>

    <!-- 標的物設備管理 -->
    <v-card flat class="rounded-lg py-2 mt-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">標的物設備管理</div>
        <div>
          <v-btn depressed color="success" class="btn_fontSize ml-2" @click="openSiteInfoAdd">新增</v-btn>
        </div>
        <div>
          <v-btn depressed color="success" class="btn_fontSize ml-2" @click="exportSiteInfoFile" :loading="isExporting">匯出</v-btn>
        </div>
        <div>
          <v-btn depressed color="success" class="btn_fontSize ml-2" @click="dialogRePwd=true">主帳號密碼重置</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="page"
            :length="pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{overview_total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="siteList"
        :headers="tables.site_info.headers"
        hide-default-header
        :items-per-page="rows"
        :loading="isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in tables.site_info.headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in tables.site_info.headers"
              :key="header.value"
              class="tableTD"
              @click="choseSite(item)"
            >
              <div v-if="header.value==='action'">
                <v-icon
                  size = "35"
                  color="success"
                  @click.stop="openSiteInfoView(item)"
                >
                  mdi-magnify
                </v-icon>
                <v-icon
                  size = "35"
                  class="ml-2"
                  color="primary"
                  @click="openSiteInfoEdit(item)"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  size = "35"
                  class="ml-2"
                  color="red"
                  @click="openSiteDeleteDialog(item)"
                >
                  mdi-delete
                </v-icon>
              </div>
              <div v-else-if ="header.value === 'auto_push'">
                <div>{{BooleanText2YN(item[header.value])}}</div>
              </div>
              <div v-else-if ="header.value === 'ProtectActivated'">
                <div>{{BooleanText2YN(item[header.value])}}</div>
              </div>
              <div v-else-if ="header.value === 'ScheduleActivated'">
                <div>{{BooleanText2YN(item[header.value])}}</div>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      <!-- 新增編輯 SiteInfo dialog -->
      <v-dialog overlay-opacity="0.2" max-width="1500px" v-model="dialogSiteInfoAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">標的物設備管理</v-card-title>
          <v-card-text>
            <div class="contentCenter">
              <v-btn-toggle
                v-model="dialogSiteInfoType"
                mandatory
              >
                <v-btn value="siteInfo" class="btn_fontSize">
                  標的物資料
                </v-btn>
                <v-btn value="deviceData" class="btn_fontSize" :disabled="!isEdit && !isView">
                  設備資料
                </v-btn>
                <v-btn value="schedultInfo" class="btn_fontSize" :disabled="!isEdit && !isView">
                  排程設解
                </v-btn>
              </v-btn-toggle>
            </div>
            <div class="contentCenter" v-if="!isEdit && !isView">
              <span>請先創建標的物再進行其他操作</span>
            </div>
            <div v-show="dialogSiteInfoType==='siteInfo'" class="mt-5">
              <v-form ref="newSiteInfoForm">
                <div class="rowDiv contentCenter">
                  <div style="width:250px">
                    <v-text-field
                      label="標的物編號"
                      v-model="selectSiteInfo.site_id"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:250px" class="ml-2">
                    <v-text-field
                      label="客戶編號"
                      v-model="selectSiteInfo.site_contract_id"
                      :rules="rules.content"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :readonly="isView"
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:250px">
                    <v-text-field
                      label="主機編號"
                      v-model="selectSiteInfo.site_mno"
                      :rules="rules.content"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :readonly="isView"
                    ></v-text-field>
                  </div>
                  <div style="width:250px" class="ml-2">
                    <v-autocomplete
                      label="主帳號"
                      v-model="selectSiteInfo.customer_id"
                      :rules="rules.content"
                      :items="customerList"
                      item-text="text"
                      item-value="value"
                      required
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      clearable
                      :readonly="isView"
                    >
                    </v-autocomplete>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:250px">
                    <v-autocomplete
                      label="所屬管制區"
                      v-model="selectSiteInfo.area_id"
                      :rules="rules.content"
                      :items="areaList"
                      item-text="text"
                      item-value="value"
                      required
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      clearable
                      :readonly="isView"
                    >
                    </v-autocomplete>
                  </div>
                  <div style="width:250px" class="ml-2">
                    <v-text-field
                      label="標的物名稱"
                      v-model="selectSiteInfo.site_nm"
                      :rules="rules.content"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :readonly="isView"
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:250px">
                    <v-text-field
                      label="標的物位置"
                      v-model="selectSiteInfo.site_location"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :readonly="isView"
                    ></v-text-field>
                  </div>
                  <div style="width:250px" class="ml-2">
                    <v-text-field
                      label="設備區域聯絡人"
                      v-model="selectSiteInfo.site_person"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :readonly="isView"
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:250px">
                    <v-text-field
                      label="聯絡電話"
                      v-model="selectSiteInfo.site_phone"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :readonly="isView"
                    ></v-text-field>
                  </div>
                  <div style="width:250px" class="ml-2">
                    <v-text-field
                      label="電子郵件"
                      v-model="selectSiteInfo.site_email"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :readonly="isView"
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter">
                  <div style="width:250px" class="ml-2">
                    <v-switch
                      class="ml-0 mb-0 pa-0"
                      v-model="selectSiteInfo.auto_push"
                      hide-details
                      true-value="True"
                      false-value="False"
                      label="自動推播"
                      :readonly="isView"
                    ></v-switch>
                  </div>
                  <div style="width:250px" class="ml-2">
                    <v-switch
                      class="ml-0 mb-0 pa-0"
                      v-model="selectSiteInfo.site_use"
                      hide-details
                      true-value="Y"
                      false-value="N"
                      label="使用中"
                      :readonly="isView"
                    ></v-switch>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:250px" class="ml-2">
                    <v-switch
                      class="ma-0 pa-0"
                      v-model="ProtectActivated"
                      hide-details
                      true-value="Y"
                      false-value="N"
                      label="保護中"
                      disabled
                    ></v-switch>
                  </div>
                  <div class="ml-2" style="width:250px">
                    <v-switch
                      class="ma-0 pa-0"
                      v-model="selectSiteInfo.s3_regular_upload"
                      dense
                      hide-details
                      :true-value="1"
                      :false-value="0"
                      label="雲端定時上傳"
                      :readonly="isView"
                    ></v-switch>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:250px" class="ml-2">
                    <v-switch
                      class="ma-0 pa-0"
                      v-model="selectSiteInfo.ScheduleActivated"
                      hide-details
                      true-value="true"
                      false-value="false"
                      label="排程設解"
                      disabled
                    ></v-switch>
                  </div>
                  <div class="ml-2" style="width:250px">
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:250px">
                    <v-text-field
                      label="攝影機回報間隔(小時)"
                      v-model.number="selectSiteInfo.delay_hours"
                      type="number"
                      :rules="rules.content"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :readonly="isView"
                    ></v-text-field>
                  </div>
                  <div class="ml-2" style="width:250px">
                    <v-text-field
                      label="雲端留存天數"
                      v-model.number="selectSiteInfo.upload_days"
                      type="number"
                      :rules="rules.content"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :readonly="isView"
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:250px">
                    <v-text-field
                      label="建立時間"
                      v-model="selectSiteInfo.create_dt"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:250px" class="ml-2">
                    <v-text-field
                      label="建立人員"
                      v-model="selectSiteInfo.create_user"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:250px">
                    <v-text-field
                      label="更新時間"
                      v-model="selectSiteInfo.update_dt"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:250px" class="ml-2">
                    <v-text-field
                      label="更新人員"
                      v-model="selectSiteInfo.update_user"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-form>
            </div>
            <div v-show="dialogSiteInfoType==='deviceData'">
              <div class="rowDiv contentCenter">
                <div>
                  <v-btn v-if="!isView" depressed  color="success" class="btn_fontSize ml-2" @click="tables.device_info.dialogDeviceInfoAdd=true">新增</v-btn>
                </div>
                <div>
                  <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="getLastEventPic" v-if="!isView">偵測與遮蔽區塊設定</v-btn>
                </div>
                <div>
                  <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="GetLiveViewUrl(1)">即時監控</v-btn>
                  <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="GetLiveViewUrl(0)">影像回放</v-btn>
                </div>
                <v-spacer>
                </v-spacer>
                <div class="text-center mr-5">
                  <v-pagination
                    circle
                    v-model="tables.device_info.devicePage"
                    :length="tables.device_info.devicePageCount"
                    total-visible=7
                  ></v-pagination>
                </div>
                <v-divider
                  class="tableDivider mr-5"
                  vertical
                  inset
                >
                </v-divider>
                <div class="text-center mr-5 contentCenter">
                  共{{tables.device_info.deviceTotal}}筆
                </div>
              </div>
              <v-data-table
                class="device-table elevation-1 rounded-lg ml-auto mr-auto mt-2"
                hide-default-footer
                :items="tables.device_info.deviceList"
                :headers="tables.device_info.deviceHeaders"
                hide-default-header
                :items-per-page="tables.device_info.deviceRows"
                :loading="isLoading"
                :expanded.sync="tables.device_info.deviceExpanded"
                item-key="device_id"
                :single-expand="true"
              >
                <template v-slot:header>
                  <thead>
                    <tr>
                      <th class="greyTh"></th>
                      <th
                        class="greyTh"
                        v-for="header in tables.device_info.deviceHeaders"
                        :key="header.value"
                      >
                        <div
                          :style="'width:'+header.width+'px'"
                          @click="changeSort(header)"
                          class="sortableThDiv"
                        >
                          <div class="sortableThDivText">
                            {{header.text}}
                          </div>
                          <div v-if="header.sortable&&tables.device_info.sortItem===header.value">
                            <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                            <v-icon v-else>mdi-chevron-up</v-icon>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:item="{ item, index }">
                  <tr 
                    @click.stop="deviceRowClick(item)"
                    class="device-row"
                    :class="{'selectedRow': item === selectDeviceInfo, 'isOdd': index % 2}"
                  >
                    <td style="padding:0px">
                      <v-btn
                        color="primary"
                        icon
                        v-show="item.subdevice.length > 0"
                      >
                        <v-icon>
                          {{
                            isDeviceExpanded(item)
                              ? 'mdi-chevron-down'
                              : 'mdi-chevron-right'
                          }}
                        </v-icon>
                      </v-btn>
                    </td>
                    <td v-for="header in tables.device_info.deviceHeaders"
                      :key="header.value"
                      class="tableTD"                  
                    >
                      <div v-if="header.value==='action'">
                        <v-icon
                          size = "35"
                          class="ml-2"
                          color="primary"
                          @click="openDeviceEdit(item)"
                          v-show="!isView"
                        >
                          mdi-pencil
                        </v-icon>
                        <v-icon
                          size = "35"
                          class="ml-2"
                          color="red" 
                          @click="openDeviceDeleteDialog(item)"
                          v-show="!isView"
                        >
                          mdi-delete
                        </v-icon>
                      </div>
                      <div v-else-if ="header.value === 'auto_push'">
                        <div>{{BooleanText2YN(item[header.value])}}</div>
                      </div>
                      <div v-else-if ="header.value === 'ProtectActivated'">
                        <div>{{BooleanText2YN(item[header.value])}}</div>
                      </div>
                      <!--只提供TD-->
                      <div v-else-if ="header.value === 'backend_ai_audio'">
                        <div>{{IntText2YN(item[header.value])}}</div>
                      </div>
                      <div v-else>
                        {{item[header.value]}}
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:expanded-item="{ item }">
                  <tr
                    v-for="(subitem, index) in item.subdevice"
                    @click.stop="deviceChnClick(subitem)"
                    :key="subitem.device_id"
                    class="expanedDeviceRow"
                    :class="{'selectedChannel': subitem.channel == tables.device_info.selectHubChannel, 'isOdd': index % 2}"
                  >
                    <td></td>
                    <td>{{ subitem.device_id }}</td>
                    <td>{{ subitem.device_nm }}</td>
                    <td>{{ subitem.device_location }}</td>

                    <td v-if="subitem.device_type === 0">CH: {{ subitem.channel }}</td>
                    <td v-else>{{ deviceTypeMap[subitem.device_type] }}</td>
                    <td>{{ BooleanText2YN(subitem.ProtectActivated) }}</td>
                    <td>{{ BooleanText2YN(subitem.auto_push) }}</td>
                    <td>{{ IntText2YN(subitem.device_use) }}</td>
                    <td>{{ subitem.device_seq }}</td>
                    <td>{{ BooleanText2YN(subitem.s3_upload) }}</td>
                    <td>{{ IntText2YN(subitem.backend_ai_audio) }}</td>
                    <td>{{ subitem.fireware_ver }}</td>
                    <td>
                      <v-icon
                        size = "35"
                        class="ml-2"
                        color="primary"
                        @click="openDeviceEdit(subitem)"
                        v-show="!isView"
                      >
                        mdi-pencil
                      </v-icon>
                      <v-icon
                        size = "35"
                        class="ml-2"
                        color="red" 
                        @click="openDeviceDeleteDialog(subitem)"
                        v-show="!isView"
                        disabled
                      >
                        mdi-delete
                      </v-icon>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  no data available
                </template>
              </v-data-table>
            </div>
            <div v-show="dialogSiteInfoType==='schedultInfo'">
              <div class="rowDiv contentCenter">
                <v-spacer>
                </v-spacer>
                <div class="text-center mr-5">
                  <v-pagination
                    circle
                    v-model="tables.schedule_info.page"
                    :length="tables.schedule_info.pageCount"
                    total-visible=10
                  ></v-pagination>
                </div>
                <v-divider
                  class="tableDivider mr-5"
                  vertical
                  inset
                >
                </v-divider>
                <div class="text-center mr-5 contentCenter">
                  共{{tables.schedule_info.total}}筆
                </div>
              </div>
              <v-data-table
                class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
                hide-default-footer
                :items="tables.schedule_info.data"
                :headers="tables.schedule_info.headers"
                hide-default-header
                :items-per-page="tables.schedule_info.rows"
                :loading="tables.schedule_info.isLoading"
              >
                <template v-slot:header>
                  <thead>
                    <tr>
                      <th
                        class="greyTh"
                        v-for="header in tables.schedule_info.headers"
                        :key="header.value"
                      >
                        <div
                          :style="'width:'+header.width+'px'"
                          @click="changeSort(header)"
                          class="sortableThDiv"
                        >
                          <div class="sortableThDivText">
                            {{header.text}}
                          </div>
                          <div v-if="header.sortable&&sortItem===header.value">
                            <v-icon v-if="tables.schedule_info.sortOrder">mdi-chevron-down</v-icon>
                            <v-icon v-else>mdi-chevron-up</v-icon>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:item ="{ item }">
                  <tr>
                    <td v-for="header in tables.schedule_info.headers"
                      :key="header.value"
                      class="tableTD"
                    >
                      <div v-if="header.value==='action'">
                      </div>
                      <div v-else-if="header.value==='site_area_id'">
                        {{ Dictionary2Text(dict.site_area_info, item.site_area_id) }}
                      </div>
                      <div v-else-if="header.value==='protect'">
                        {{ Dictionary2Text(dict.security_on_off, item.protect) }}
                      </div>
                      <div v-else-if="header.value==='Activated'">
                        {{ IntText2YN(item.Activated) }}
                      </div>
                      <div v-else>
                        {{item[header.value]}}
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  no data available
                </template>
              </v-data-table>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeSiteInfoDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveSiteInfo" v-show="!isView">儲存</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 新增標的物會員管理dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="tables.site_share_info.dialogSiteShareInfoAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">新增標的物會員</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <v-form ref="newPermissionForm">
                <div class="rowDiv contentCenter" >
                  <div style="width:190px" class="ml-2 btn_fontSize">
                  </div>
                  <div style="width:200px">
                    <v-autocomplete
                      label="會員編號"
                      v-model="selectSiteShareInfoItem.account_id"
                      :items="accountList"
                      item-text="text"
                      item-value="value"
                      required
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      clearable
                    >
                    </v-autocomplete>
                  </div>
                  <div style="width:150px" class="ml-2">
                    <v-text-field
                      label="標的物"
                      v-model="selectSiteShareInfoItem.site_id"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                    ></v-text-field>
                  </div>
                  <v-icon
                    size = "35"
                    color="green"
                    @click="dialogSiteIdAdd=true"
                  >
                    mdi-magnify
                  </v-icon>
                  <div style="width:200px" class="ml-2 btn_fontSize">
                    <span>{{selectSiteShareInfoItem.site_nm}}</span>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-select
                      :items="permissionList"
                      outlined
                      class="rounded-lg"
                      dense
                      v-model="selectSiteShareInfoItem.PermissionType_ext"
                      hide-details
                      label="權限別"
                      :rules="rules.content"
                    >
                    </v-select>
                  </div>
                  <div style="width:200px" class="ml-2 rowDiv">
                    <v-menu
                      ref="searchExpireDateMenu"
                      v-model="searchExpireDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="auto"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="selectSiteShareInfoItem.PermissionExpiredTime"
                          readonly
                          v-bind="attrs"
                          v-on="on"
                          outlined
                          class="rounded-lg"
                          dense
                          hide-details
                          label="有效結束日"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="selectSiteShareInfoItem.PermissionExpiredTime"
                        @input="searchExpireDateMenu = false"
                        no-title
                        scrollable
                      >
                      </v-date-picker>
                    </v-menu>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-text-field
                      label="建立時間"
                      v-model="selectSiteShareInfoItem.create_dt"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="建立人員"
                      v-model="selectSiteShareInfoItem.create_user"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-text-field
                      label="更新時間"
                      v-model="selectSiteShareInfoItem.update_dt"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="更新人員"
                      v-model="selectSiteShareInfoItem.update_user"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeSiteShareInfoDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveSiteShareInfoData">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 新增標的物dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="dialogSiteIdAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">標的物查詢</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <div class="rowDiv">
                <div style="width:200px">
                  <v-text-field
                    label="搜尋"
                    v-model="searchSiteDetail"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                  ></v-text-field>
                </div>
                <v-spacer>
                </v-spacer>
                <div class="text-center mr-5">
                  <v-pagination
                    circle
                    v-model="sitePage"
                    :length="sitePageCount"
                    total-visible=7
                  ></v-pagination>
                </div>
                <v-divider
                  class="tableDivider mr-5"
                  vertical
                  inset
                >
                </v-divider>
                <div class="text-center mr-5 contentCenter">
                  共{{siteTotal}}筆
                </div>
              </div>
              <v-data-table
                class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
                hide-default-footer
                :items="tables.site_info.siteInfoTableList"
                :headers="tables.site_info.siteInfoHeader"
                :items-per-page="10"
                height="550"
                :page.sync="sitePage"
                :loading="isLoading"
              >
                <template v-slot:item="{ item }">
                  <tr>
                    <td
                      v-for="header in tables.site_info.siteInfoHeader"
                      :key="header.value"
                      class="tableTD"
                      @click="selectSite(item)"
                    >
                      <div>
                        {{item[header.value]}}
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  no data available
                </template>
              </v-data-table>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn cancelBtnColor" @click="dialogSiteIdAdd=false">關閉</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 標的物區域dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="tables.site_area_detail.dialogView" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">標的物區域管理</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <div class="rowDiv">
                <div style="width:200px">
                  <v-text-field
                    label="區域名稱"
                    v-model="tables.site_area_detail.selectedData.AreaName"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    disabled
                  ></v-text-field>
                </div>
                <v-spacer>
                </v-spacer>
                <div class="text-center mr-5">
                  <v-pagination
                    circle
                    v-model="tables.site_area_detail.page"
                    :length="tables.site_area_detail.pageCount"
                    total-visible=7
                  ></v-pagination>
                </div>
                <v-divider
                  class="tableDivider mr-5"
                  vertical
                  inset
                >
                </v-divider>
                <div class="text-center mr-5 contentCenter">
                  共{{tables.site_area_detail.total}}筆
                </div>
              </div>
              <v-data-table
                class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
                hide-default-footer
                :items="tables.site_area_detail.data"
                :headers="tables.site_area_detail.headers"
                :items-per-page="tables.site_area_detail.rows"
                hide-default-header
                :loading="tables.site_area_detail.isLoading"
              >
                <template v-slot:header>
                  <thead>
                    <tr>
                      <th
                        class="greyTh"
                        v-for="header in tables.site_area_detail.headers"
                        :key="header.value"
                      >
                        <div
                          :style="'width:'+header.width+'px'"
                          @click="changeSort(header)"
                          class="sortableThDiv"
                        >
                          <div class="sortableThDivText">
                            {{header.text}}
                          </div>
                          <div v-if="header.sortable&&sortItem===header.value">
                            <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                            <v-icon v-else>mdi-chevron-up</v-icon>
                          </div>
                        </div>
                      </th>
                    </tr>
                  </thead>
                </template>
                <template v-slot:item="{ item }">
                  <tr>
                    <td
                      v-for="header in tables.site_area_detail.headers"
                      :key="header.value"
                      class="tableTD"
                    >
                      <div>
                        {{item[header.value]}}
                      </div>
                    </td>
                  </tr>
                </template>
                <template v-slot:no-data>
                  no data available
                </template>
              </v-data-table>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn cancelBtnColor" @click="tables.site_area_detail.dialogView=false">關閉</v-btn>
            <v-spacer></v-spacer>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 主帳號密碼重製dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="dialogRePwd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">主帳號密碼重製</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <div class="rowDiv contentCenter">
                <v-form ref="repwdForm">
                  <div style="width:400px">
                    <v-text-field
                      label="主機編號"
                      v-model="selectRePwd.site_mno"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                    ></v-text-field>
                  </div>
                </v-form>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeRePwd">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveRePwd">確定</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 新增編輯device info dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="tables.device_info.dialogDeviceInfoAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">{{dialogDeviceInfoTitle}}</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <v-form ref="newDeviceInfoForm">
                <div class="rowDiv contentCenter" >
                  <div style="width:200px">
                    <v-text-field
                      label="設備編號"
                      v-model="selectDeviceInfo.device_id"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="設備名稱"
                      v-model="selectDeviceInfo.device_nm"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-text-field
                      label="設備位置"
                      v-model="selectDeviceInfo.device_location"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2 rowDiv">
                    <v-autocomplete
                      label="設備類型"
                      v-model="selectDeviceInfo.device_type"
                      :items="deviceTypeList"
                      item-text="text"
                      item-value="value"
                      required
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details

                      clearable
                      v-show="tables.device_info.isDeviceEdit"
                      disabled
                    >
                    </v-autocomplete>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-switch
                      class="ma-0 pa-0"
                      v-model="selectDeviceInfo.ProtectActivated"
                      hide-details
                      true-value="true"
                      false-value="false"
                      label="警戒中"
                      disabled
                    ></v-switch>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-switch
                      class="ma-0 pa-0"
                      v-model="selectDeviceInfo.auto_push"
                      hide-details
                      true-value="True"
                      false-value="False"
                      label="自動推播"
                    ></v-switch>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-switch
                      class="ma-0 pa-0"
                      v-model="selectDeviceInfo.device_use"
                      hide-details
                      true-value="Y"
                      false-value="N"
                      label="使用中"
                    ></v-switch>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="迴路序號"
                      v-model.number="selectDeviceInfo.device_seq"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      type="number"
                      :rules="rules.content"
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-text-field
                      label="建立時間"
                      v-model="selectDeviceInfo.create_dt"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="建立人員"
                      v-model="selectDeviceInfo.create_user"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-text-field
                      label="更新時間"
                      v-model="selectDeviceInfo.update_dt"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="更新人員"
                      v-model="selectDeviceInfo.update_user"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-switch
                      class="ma-0 pa-0"
                      v-model="selectDeviceInfo.s3_upload"
                      hide-details
                      true-value="Y"
                      false-value="N"
                      label="事件錄影儲存雲端"
                    ></v-switch>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="韌體版本"
                      v-model="selectDeviceInfo.firmware_ver"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      disabled
                    ></v-text-field>
                  </div>
                </div>
                <div class="rowDiv contentCenter mt-5">
                  <div style="width:200px">
                    <v-switch
                      class="ma-0 pa-0"
                      v-model="selectDeviceInfo.backend_ai_audio"
                      hide-details
                      :true-value=1
                      :false-value=0
                      label="後端發報"
                    ></v-switch>
                  </div>
                  <div style="width:200px" class="ml-2">
                    <v-switch
                      class="ma-0 pa-0"
                      v-model="selectDeviceInfo.r6_send"
                      hide-details
                      true-value='True'
                      false-value='False'
                      label="R6訊號傳送"
                      disabled
                    ></v-switch>
                  </div>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDeviceInfoDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="saveDeviceInfo">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 新增編輯device location dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="tables.device_location.dialogDeviceLocation" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">區塊繪製設定</v-card-title>
          <v-card-text>
            <div class="mt-5 rowDiv">
              <div class="css_td">
                <fieldset class="pa-2" style="min-width: 200px;min-height:80px;">
                  <legend style="font-size: 20px; font-weight: bold; margin-left:20px">繪製對象</legend>
                  <v-btn-toggle
                    v-model="tables.device_location.drawTarget"
                    rounded
                    color="deep-purple-accent-3"
                    group
                    mandatory
                  >
                    <v-btn value="L" class="dialogbtn" v-if="dialogs.const_model_thremal!=tables.device_location.target.device_model">{{ dialogs.ai_location_name }}</v-btn>
                    <v-btn value="S" class="dialogbtn">{{ dialogs.di_location_name }}</v-btn>
                  </v-btn-toggle>
                </fieldset>
              </div>
              <div class="css_td ml-2">
                <fieldset class="pa-2" style="min-height:80px;width: 200px;">
                  <legend style="font-size: 20px; font-weight: bold; margin-left:20px">區塊清單</legend>
                  <div class="rowDiv">
                    <v-btn
                      v-for="(data, index) in tables.device_location.regionList"
                      :key="index" class="cancelBtnColor ma-1"
                      small
                      @click="selectRegion(tables.device_location.paintstatu, index)"
                    >
                      {{index}}
                    </v-btn>
                  </div>
                  <v-btn class="dialogbtn subBtnColor mt-2" @click="removeRegion">移除指定區塊</v-btn>
                </fieldset>
              </div>
              <div class="ml-2 css_td" id="ATool">
                <fieldset class="pa-2" style="min-width: 200px;min-height:80px;max-width: 500px;">
                  <legend style="font-size: 20px; font-weight: bold; margin-left:20px">AI設定功能</legend>
                  <div style="width:300px" class="rowDiv">
                    <v-select
                      :items="modelInfoList"
                      outlined
                      class="rounded-lg"
                      dense
                      v-model="tables.device_location.target.ai_model"
                      hide-details
                    >
                    </v-select>
                    <v-text-field
                      v-model="tables.device_location.target.ai_param"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                    ></v-text-field>
                    <v-switch
                      class="ma-0 pa-0"
                      v-model="tables.device_location.target.isSendAIS2"
                      label="二次辨識"
                      dense
                      outlined
                      hide-details
                      :true-value="1"
                      :false-value="0"
                    >二次辨識</v-switch>
                  </div>
                  <v-btn class="dialogbtn subBtnColor mt-2" @click="dialogModelAdd = true">新增模型</v-btn>
                  <v-btn class="dialogbtn subBtnColor mt-2 ml-2" @click="dialogModelDelete=true">移除模型</v-btn>
                </fieldset>                
              </div>
            </div>
            <div class="mt-5 rowDiv">
              <div
                class="background"
                style="width: 800px; height: 600px; background-size: 100% 100%;"
                :style="{'background-image': tables.device_location.image}"
                >
                <canvas id="canvas" width="800px" height="600px" @click="mouseClick" @mousemove="mouseMove"></canvas>
                <canvas id="canvasSave" width="800px" height="600px"></canvas>
                <canvas id="Scanvas" width="800px" height="600px"></canvas>
                <canvas id="Lcanvas" width="800px" height="600px"></canvas>
              </div>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDialogDeviceLocation">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="resetLocation">全部重設</v-btn>
            <v-btn class="dialogbtn subBtnColor ml-2" @click="saveDeviceLocation">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 新增編輯model info dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="dialogModelAdd" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">新增 Model</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <v-form ref="newModelInfoForm">
                <div class="rowDiv contentCenter" >
                  <div style="width:200px" class="ml-2">
                    <v-text-field
                      label="Model名稱"
                      v-model="selectModel.model_name"
                      class="rounded-lg"
                      dense
                      outlined
                      hide-details
                      :rules="rules.content"
                    ></v-text-field>
                  </div>
                </div>
              </v-form>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDialogModelAdd">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="AddModel">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 刪除model info dialog -->
      <v-dialog overlay-opacity="0.2" max-width="900px" v-model="dialogModelDelete" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除 Model</v-card-title>
          <v-card-text>
            <div class="mt-5">
              <v-card-title class="headline justify-center font-weight-bold">是否確認刪除 {{selectDeviceInfo.ai_model}}</v-card-title>
            </div>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="dialogModelDelete=false">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteModel">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      
      <!-- 確認刪除標的物dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="dialogSiteDelete" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除標的物</v-card-title>
          <v-card-text>
            <v-form ref="deleteSiteForm">
              <div class="rowDiv contentCenter">
                <div style="width:180px">
                  <v-text-field
                    label="標的物編號"
                    v-model="deleteSiteItem.site_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
                <div style="width:180px" class="ml-2">
                  <v-text-field
                    label="標的物姓名"
                    v-model="deleteSiteItem.site_nm"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter">
                <div style="width:180px" class="mt-5">
                  <v-text-field
                    label="標的物主機編號"
                    v-model="deleteSiteItem.site_mno"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
                <div style="width:180px" class="ml-2 mt-5">
                  <v-text-field
                    label="主帳號"
                    v-model="deleteSiteItem.customer_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeSiteDeleteDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteSite">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
      <!-- 確認刪除設備dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="tables.device_info.dialogDeviceDelete" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除設備</v-card-title>
          <v-card-text>
            <v-form ref="deleteDeviceForm">
              <div class="rowDiv contentCenter">
                <div style="width:360px">
                  <v-text-field
                    label="設備編號"
                    v-model="selectDeviceInfo.device_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
                <div style="width:180px" class="ml-2">
                  <v-text-field
                    label="設備姓名"
                    v-model="selectDeviceInfo.device_nm"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeDeviceDeleteDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteDevice">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <!-- 標的物區域管理 -->
    <v-card flat class="rounded-lg py-2 mt-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">標的物區域管理</div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="tables.site_area_info.page"
            :length="tables.site_area_info.pageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{tables.site_area_info.total}}筆
        </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="tables.site_area_info.rows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="tables.site_area_info.data"
        :headers="tables.site_area_info.headers"
        hide-default-header
        :items-per-page="tables.site_area_info.rows"
        :loading="tables.site_area_info.isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in tables.site_area_info.headers"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in tables.site_area_info.headers"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value==='action'">
                <v-icon
                  size = "35"
                  color="success"
                  @click="openSiteAreaInfoView(item)"
                >
                  mdi-magnify
                </v-icon>
              </div>
              <div v-else-if ="header.value === 'ActiveLinked'">
                <div>{{BooleanText2YN(item[header.value])}}</div>
              </div>
              <div v-else-if ="header.value === 'DeactiveLinked'">
                <div>{{BooleanText2YN(item[header.value])}}</div>
              </div>
              <div v-else-if ="header.value === 'ProtectActivated'">
                <div>{{BooleanText2YN(item[header.value])}}</div>
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
    </v-card>
    
    <!-- 標的物會員管理 -->
    <v-card flat class="rounded-lg py-2 mt-2" height="100%">
      <div class="rowDiv contentCenter px-2">
        <div class="rounded-lg pa-1 pageTitle font-weight-black text-h5" style="width: 200px;">標的物會員管理</div>
        <div>
          <v-btn depressed  color="success" class="btn_fontSize ml-2" @click="openSiteShareInfoAdd">新增</v-btn>
        </div>
        <v-spacer>
        </v-spacer>
        <div class="text-center mr-5">
          <v-pagination
            circle
            v-model="tables.site_share_info.siteSharePage"
            :length="tables.site_share_info.siteSharePageCount"
            total-visible=7
          ></v-pagination>
        </div>
        <v-divider
          class="tableDivider mr-5"
          vertical
          inset
        >
        </v-divider>
        <div class="text-center mr-5 contentCenter">
          共{{tables.site_share_info.site_share_total}}筆
       </div>
        <!-- 每頁顯示筆數 -->
        <div style="width:180px">
          <v-select
            :items="rowsList"
            outlined
            class="rounded-lg"
            dense
            v-model="tables.site_share_info.siteShareRows"
            hide-details
            prefix="每頁顯示"
            suffix="筆"
          >
          </v-select>
        </div>
      </div>
      <v-data-table
        class="elevation-1 rounded-lg ml-auto mr-auto mt-2"
        hide-default-footer
        :items="tables.site_share_info.siteShareInfoList"
        :headers="tables.site_share_info.siteShareHeaders"
        hide-default-header
        :items-per-page="tables.site_share_info.siteShareRows"
        :loading="isLoading"
      >
        <template v-slot:header>
          <thead>
            <tr>
              <th
                class="greyTh"
                v-for="header in tables.site_share_info.siteShareHeaders"
                :key="header.value"
              >
                <div
                  :style="'width:'+header.width+'px'"
                  @click="changeSort(header)"
                  class="sortableThDiv"
                >
                  <div class="sortableThDivText">
                    {{header.text}}
                  </div>
                  <div v-if="header.sortable&&sortItem===header.value">
                    <v-icon v-if="sortOrder">mdi-chevron-down</v-icon>
                    <v-icon v-else>mdi-chevron-up</v-icon>
                  </div>
                </div>
              </th>
            </tr>
          </thead>
        </template>
        <template v-slot:item="{ item }">
          <tr>
            <td v-for="header in tables.site_share_info.siteShareHeaders"
              :key="header.value"
              class="tableTD"
            >
              <div v-if="header.value==='action'">
                <v-icon
                  size = "35"
                  color="red"
                  @click="openSiteShareDeleteDialog(item)"
                >
                  mdi-delete
                </v-icon>
              </div>
              <div v-else-if="header.value==='PermissionType'">
                {{PermissionType2Text(item.PermissionType_ext)}}
              </div>
              <div v-else>
                {{item[header.value]}}
              </div>
            </td>
          </tr>
        </template>
        <template v-slot:no-data>
          no data available
        </template>
      </v-data-table>
      
      <!-- 確認刪除標的物會員dialog -->
      <v-dialog overlay-opacity="0.2" max-width="600px" v-model="dialogSiteShareDelete" persistent>
        <v-card>
          <v-card-title class="headline justify-center font-weight-bold">刪除標的物會員</v-card-title>
          <v-card-text>
            <v-form ref="deleteSiteShareForm">
              <div class="rowDiv contentCenter">
                <div style="width:180px">
                  <v-text-field
                    label="標的物編號"
                    v-model="deleteSiteShareItem.site_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
              <div class="rowDiv contentCenter mt-5">
                <div style="width:180px">
                  <v-text-field
                    label="會員編號"
                    v-model="deleteSiteShareItem.account_id"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
                <div style="width:180px" class="ml-2">
                  <v-text-field
                    label="會員姓名"
                    v-model="deleteSiteShareItem.account_name"
                    class="rounded-lg"
                    dense
                    outlined
                    hide-details
                    readonly
                  ></v-text-field>
                </div>
              </div>
            </v-form>
          </v-card-text>
          <v-card-actions>
            <v-btn class="dialogbtn cancelBtnColor" @click="closeSiteShareDeleteDialog">關閉</v-btn>
            <v-spacer></v-spacer>
            <v-btn class="dialogbtn subBtnColor" @click="deleteSiteShareInfoData">確認</v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </v-card>

    <!-- 搜尋 sidebar -->
    <v-navigation-drawer
      app
      clipped
      class="rounded-lg mt-3"
      :width="sidebarWidth"
      height="850"
      permanent
    >
      <div class="rowDiv">
        <v-card-title v-if="sidebarOpen" class="headline font-weight-bold">篩選條件</v-card-title>
        <v-spacer>
        </v-spacer>
        <v-icon
          size = "30"
          style="cursor: pointer;"
          class="mr-5"
          v-if='sidebarOpen'
          @click="sidebarOpen=!sidebarOpen"
        >
          mdi-arrow-expand-left
        </v-icon>
        <v-icon
          size = "30"
          style="cursor: pointer;"
          class="mr-5 mt-5"
          v-else
          @click="sidebarOpen=!sidebarOpen"
        >
          mdi-tune-variant
        </v-icon>
      </div>
      <v-divider></v-divider>
      <div v-if="sidebarOpen">
        <v-card-title style="height:50px;" class="searchTitle">標的物編號</v-card-title>
        <div style="width:220px; height:30px" class="ml-4">
          <v-text-field
            v-model="searchSiteId"
            class="rounded-lg"
            dense
            outlined
            hide-details
          ></v-text-field>
        </div>
        <v-card-title style="height:50px;" class="searchTitle">主機編號</v-card-title>
        <div style="width:220px; height:30px" class="ml-4">
          <v-text-field
            v-model="searchSiteMNO"
            class="rounded-lg"
            dense
            outlined
            hide-details
          ></v-text-field>
        </div>
        <v-card-title style="height:50px;" class="searchTitle">主帳號</v-card-title>
        <div style="width:220px; height:30px" class="ml-4">
          <v-autocomplete
            v-model="searchCustomerId"
            :items="customerList"
            item-text="text"
            item-value="value"
            required
            class="rounded-lg"
            dense
            outlined
            hide-details
            clearable
          >
          </v-autocomplete>
        </div>
        <v-card-title style="height:50px;" class="searchTitle">標的物名稱</v-card-title>
        <div style="width:220px; height:30px" class="ml-4">
          <v-text-field
            v-model="searchSiteName"
            class="rounded-lg"
            dense
            outlined
            hide-details
          ></v-text-field>
        </div>
        <v-card-title style="height:50px;" class="searchTitle">合約編號</v-card-title>
        <div style="width:220px; height:30px" class="ml-4">
          <v-text-field
            v-model="searchSiteContractId"
            class="rounded-lg"
            dense
            outlined
            hide-details
          ></v-text-field>
        </div>
        <v-divider class="mt-5"></v-divider>
        <v-card-title style="height:50px;" class="searchTitle">篩選設備所屬標的</v-card-title>
        <div style="width:220px; height:30px" class="ml-4">
          <v-text-field
            label="設備編號或MAC號碼"
            style="font-size: 0.7em;"
            v-model="searchSiteByDevice"
            class="rounded-lg"
            dense
            outlined
            hide-details
          ></v-text-field>
        </div>
        <v-divider class="mt-5"></v-divider>
        <v-card-title style="height:50px;" class="searchTitle">設備解綁<v-btn small depressed color="success" class="btn_fontSize ml-2" @click="device_unlock">解綁</v-btn></v-card-title>
        
        <div style="width:220px; height:30px" class="ml-4">
          <v-text-field
            label="設備編號"
            style="font-size: 0.7em;"
            v-model="device_function_area.device_id"
            class="rounded-lg"
            dense
            outlined
            hide-details
          ></v-text-field>
        </div>
        <div style="width:220px; height:30px" class="ml-4">
          
        </div>
      </div>
    </v-navigation-drawer>
  </v-container>
</template>
<script>
// import axios from 'axios'
// import router from '../router'
import Service from '../service/service'
import HuntHelper from '../components/HuntHelper.js' // Import from the js location
import MDHelper from '../components/MDHelper.js' // Import from the js location
import RecHelper from '../components/RecHelper.js'
export default {
  name: 'Site_Info',
  data: () => ({
    tables: {
      schedule_info: {
        enabled: false,
        isLoading: false,
        urlGet: 'site_info/GetPageData_schedule',
        headers: [
          //{ text: '編號', value: 'schedule_id',  sortable: false },
          //{ text: '標的物編號', value: 'site_id',  sortable: false },
          { text: '標的物區域', value: 'site_area_id',  sortable: false },
          { text: '時間', value: 'starttime',  sortable: false },
          { text: '設解', value: 'protect',  sortable: false },
          { text: '排程日', value: 'weekdaylist',  sortable: false },
          { text: '啟用', value: 'Activated',  sortable: false },
          //{ text: 'create_dt', value: 'create_dt',  sortable: false },
          //{ text: 'create_user', value: 'create_user',  sortable: false },
          { text: '最後設定時間', value: 'update_dt',  sortable: false },
          { text: '最後設定人員', value: 'update_user',  sortable: false },
          { text: '', value: 'actions', sortable: false }
        ],
        rows: 50,
        sortItem: 'schedule_id',
        sortOrder: false,
        pageCount: 0,
        page: 1,
        total: 0,
        rowsList: [10, 20, 30, 40, 50],
        search: {
          site_id: {
              name: 'site_id',
              value: '',
              displayType: '='
          },
        },
        data: [],
      },
      site_area_info: {
        isLoading: false,
        urlGet: 'site_area_info/getPageData',
        headers: [
          { text: '區域名稱', value: 'AreaName', sortable: false },
          { text: '設防連動', value: 'ActiveLinked', sortable: false },
          { text: '撤防連動', value: 'DeactiveLinked', sortable: false },
          { text: '警戒中', value: 'ProtectActivated', sortable: false },
          { text: '最後設定人員', value: 'LastProtectedUser', sortable: false },
          { text: '最後設定時間', value: 'LastProtectedTime', sortable: false },
          { text: '區域編號', value: 'site_area_seq', sortable: false },
          { text: '', value: 'action',  sortable: false }
        ],
        rows: 10,
        sortItem: 'AreaName',
        sortOrder: false,
        pageCount: 0,
        page: 1,
        total: 0,
        rowsList: [10, 20, 30, 40, 50],
        search: {
          site_id: {
              name: 'site_id',
              value: '',
              displayType: '='
          },
        },
        data: [],
        dialogView: false
      },
      site_area_detail: {
        isLoading: false,
        urlGet: 'site_area_info_detail/getPageData',
        headers: [
          { text: '設備名稱', value: 'device_nm', sortable: false },
        ],
        rows: 10,
        sortItem: 'device_nm',
        sortOrder: false,
        pageCount: 0,
        page: 1,
        total: 0,
        rowsList: [10, 20, 30, 40, 50],
        search: {
          site_id: {
              name: 'site_id',
              value: '',
              displayType: '='
          },
        },
        selectedData: {
          AreaID: '',
          site_id: '',
          AreaName: ''
        },
        data: [],
        dialogView: false
      },
      site_info: {
        headers: [
          { text: '主機編號', value: 'site_mno', sortable: false },
          { text: '所屬管制區', value: 'area_name', sortable: false },
          { text: '標的物名稱', value: 'site_nm', sortable: false },
          { text: '警戒中', value: 'ProtectActivated',  sortable: false },
          { text: '排程設解', value: 'ScheduleActivated',  sortable: false },
          { text: '自動推播', value: 'auto_push',  sortable: false },
          { text: '最後設定人員	', value: 'LastProtectedUser',  sortable: false },
          { text: '最後設定時間', value: 'LastProtectedTime',  sortable: false },
          { text: '', value: 'action',  sortable: false }
        ],
        siteInfoHeader: [
          { text: '標的物編號', value: 'site_id', sortable: false },
          { text: '主機編號', value: 'site_mno', sortable: false },
          { text: '標的物名稱', value: 'site_nm', sortable: false },
        ],
        siteInfoTableList: [],
        defaultItem: {
          LastProtectedTime: '',
          LastProtectedUser: '',
          ProtectActivated: 'False',
          ScheduleActivated: 'false',
          area_id: '',
          auto_push: 'False',
          create_dt: '',
          create_user: '',
          customer_id: '',
          delay_hours: '1',
          online_dt: null,
          site_alert: null,
          site_contract_id: '',
          site_email: '',
          site_id: '',
          site_location: '',
          site_mno: '',
          site_nm: '',
          site_person: '',
          site_phone: '',
          site_sort: 0,
          site_use: 'Y',
          unline_dt: null,
          update_dt: '',
          update_user: '',
          upload_days: '1',
          s3_regular_upload: 0
        }
      },
      site_share_info: {
        siteShareHeaders: [
          { text: '標的物編號', value: 'site_id', sortable: false },
          { text: '會員編號', value: 'account_id', sortable: false },
          { text: '會員姓名', value: 'account_name', sortable: false },
          { text: '權限別', value: 'PermissionType', sortable: false },
          { text: '有效結束日', value: 'PermissionExpiredTime', sortable: false },
          { text: '', value: 'action',  sortable: false }
        ],
        siteShareRows: 10,
        siteSharePageCount: 0,
        siteSharePage: 1,
        site_share_total: 0,
        searchSiteShareId: '',
        dialogSiteShareInfoAdd: false,
        siteShareInfoList: [],
      },
      device_info: {
        urlGet: 'device_info/getPageData',
        sortItem: 'site_id',
        sortOrder: false,
        devicePage: 1,
        devicePageCount: 1,
        deviceTotal: 0,
        deviceRows: 10,
        deviceList: [],
        deviceHeaders: [
          { text: '設備編號', value: 'device_id', sortable: false },
          { text: '設備名稱', value: 'device_nm', sortable: false },
          { text: '設備位置', value: 'device_location', sortable: false },
          { text: '設備類型', value: 'device_type_nm', sortable: false },
          { text: '警戒中', value: 'ProtectActivated', width: '42', sortable: false },
          { text: '自動推播', value: 'auto_push', width: '42', sortable: false },
          { text: '使用中', value: 'device_use', width: '42', sortable: false },
          { text: '迴路序號', value: 'device_seq', width: '42', sortable: false },
          { text: '事件錄影儲存雲端', value: 's3_upload', width: '84', sortable: false },
          { text: '後端發報', value: 'backend_ai_audio', width: '84', sortable: false },
          { text: '韌體版本', value: 'firmware_ver', width: '84', sortable: false },
          { text: '', value: 'action',  sortable: false, width: '100' }
        ],
        selectHubChannel: 0,
        deviceExpanded: [],
        isDeviceEdit: false,
        dialogDeviceInfoAdd: false,
        dialogDeviceDelete: false,

        defaultItem: {
          LastLiveTime: null,
          LastProtectedTime: '',
          LastProtectedUser: '',
          LastStatusTime: null,
          Password: null,
          ProtectActivated: 'false',
          Username: null,
          ai_model: 'model_v2',
          ai_param: '0.5',
          auto_push: 'True',
          backend_ai_audio: 0,
          create_dt: '',
          create_user: '',
          ddnsStatus: null,
          device_ai_location: '',
          device_di_location: '',
          device_id: '',
          device_live: null,
          device_location: '',
          device_nm: '',
          device_protection: '',
          device_seq: null,
          device_status: null,
          device_type: null,
          device_use: 'N',
          firmware_ver: '',
          locationStatus: null,
          r6_send: 'True',
          s3_upload: 'Y',
          site_id: '',
          update_dt: '',
          update_user: '',
          isSendAIS2: 0,
          scheduled_voice: 0,
          scheduled_flash: 0
        },
      },
      device_location:{
        target: {},
        dialogDeviceLocation: false,

        LineWidth: 4, // 線條粗細
        GlobalAlpha: 0.8, // 透明度
        SelectedEdgeStyle: 'rgba(200,200,0,1)',  // 黃
        SelectedFillStyle: 'rgba(220,220,40,1)',
        DefaultFillStyle: 'rgba(161,195,255,1)',// 藍
        DefaultEdgeStyle: 'rgba(102,168,255,1)',
        LocationEdgeStyle: 'rgba(237,28,36,1)',  // 紅
        LocationFillStyle: 'rgba(230,36,55,1)',
        ShadeEdgeStyle: 'rgba(0,177,40,1)',   // 綠
        ShadeFillStyle: 'rgba(34,177,76,1)',

        can: null,
        ctx: null,
        canSave: null,
        ctxSave: null,
        scan: null,
        sctx: null,
        lcan: null,
        lctx: null,

        regionSet: [],//存放所有操作中的區域
        pointArr: [],//存放坐标的數组
        regionList: [],
        selectedRegion: {},
        
        drawTarget: 'L',
        paintstatu: '',
        oIndex: -1, //判断鼠标是否移动到起始點处，-1為否，1為是
        pointX: 0,
        pointY: 0,
        image: '',
        default_ai: '',             // 未修改前 數值，非系統預設值
        default_di: '',             // 未修改前 數值，非系統預設值
        default_model: 'model_v2',  // 未修改前 數值，非系統預設值
        default_param: '0.5',       // 未修改前 數值，非系統預設值
      }
    },
    
    dialogs: {
      const_model_thremal: 'AS-T5014RES-32F-2',

      ai_location_name: '偵測區塊',
      di_location_name: '遮蔽區塊',
      const_camera__ai_name: '偵測區塊',
      const_camera__di_name: '遮蔽區塊',
      const_thermal_ai_name: '',
      const_thermal_di_name: '測煙/測溫遮蔽區塊',
    },
    isLoading: false,
    isExporting: false,
    rows: 10,
    sortItem: 'site_id',
    sortOrder: false,
    overview_total: 0,
    pageCount: 0,
    page: 1,
    rowsList: [10, 20, 30, 40, 50],
    controlPermission: [],
    siteList: [],
    areaList: [],
    allUsersList: [],
    customerList: [],
    accountList: [],
    sidebarOpen: true,
    sidebarWidth: 260,
    searchCustomerId: '',
    searchSiteId: '',
    searchSiteMNO: '',
    searchSiteName: '',
    searchSiteContractId: '',
    dialogSiteInfoAdd: false,
    selectSiteInfo: {
      LastProtectedTime: '',
      LastProtectedUser: '',
      ProtectActivated: 'False',
      ScheduleActivated: 'False',
      area_id: '',
      auto_push: 'False',
      create_dt: '',
      create_user: '',
      customer_id: '',
      delay_hours: '1',
      online_dt: null,
      site_alert: null,
      site_contract_id: '',
      site_email: '',
      site_id: '自動編號',
      site_location: '',
      site_mno: '',
      site_nm: '',
      site_person: '',
      site_phone: '',
      site_sort: 0,
      site_use: 'Y',
      unline_dt: null,
      update_dt: '',
      update_user: '',
      upload_days: '1',
      s3_regular_upload: 0
    },
    selectSiteShareInfoItem: {
      PermissionExpiredTime: '',
      PermissionType: '',
      PermissionType_ext: 0,
      account_id: '',
      card: null,
      create_dt: '',
      create_user: '',
      role: null,
      site_id: '',
      site_nm: '',
      update_dt: '',
      update_user: ''
    },
    isView: false,
    isEdit: false,
    dialogSiteInfoType: 'siteInfo',
    rules: {
      content: [v => !!v || 'Required']
    },
    permissionList: [],
    searchExpireDateMenu: false,
    dialogSiteIdAdd: false,
    siteTotal: 0,
    sitePage: 1,
    sitePageCount: 0,
    searchSiteDetail: '',
    deviceInfoList: [],
    searchSiteByDevice: '',
    dialogRePwd: false,
    selectRePwd: {
      site_mno: ''
    },
    deviceTypeList: [],
    deviceTypeMap: {},
    selectDeviceInfo: {
      LastLiveTime: null,
      LastProtectedTime: '',
      LastProtectedUser: '',
      LastStatusTime: null,
      Password: null,
      ProtectActivated: 'false',
      Username: null,
      ai_model: 'model_v2',
      ai_param: '0.5',
      auto_push: 'True',
      backend_ai_audio: 0,
      create_dt: '',
      create_user: '',
      ddnsStatus: null,
      device_ai_location: '',
      device_di_location: '',
      device_id: '',
      device_live: null,
      device_location: '',
      device_nm: '',
      device_protection: '',
      device_seq: null,
      device_status: null,
      device_type: null,
      device_use: 'N',
      firmware_ver: '',
      locationStatus: null,
      r6_send: 'True',
      s3_upload: 'Y',
      site_id: '',
      update_dt: '',
      update_user: '',
      isSendAIS2: 0,
      scheduled_voice: 0,
      scheduled_flash: 0
    },
    

    MODE_ACtrl: false,

    modelInfoList: [],
    dialogModelAdd: false,
    selectModel: {
      model_name: ''
    },
    dialogModelDelete: false,
    dialogSiteDelete: false,
    deleteSiteItem: {
      site_id: '',
      site_mno: '',
      site_nm: '',
      area_id: '',
      customer_id: ''
    },
    dialogSiteShareDelete: false,
    deleteSiteShareItem: {
      site_id: '',
      account_id: '',
      account_name: ''
    },
    area_checked_timer: null,
    area_checked: [{area_id:'', area_nm:''}],
    areaListFilter: [],
    device_function_area:{
      device_id: ''
    },
    dict: {
      siteInfoList: [],
      site_area_info: [{ key: '', value: '' }],
      security_on_off: [{ key: '1', value: '設防' },{ key: '0', value: '解防' }]
    }
  }),
  mounted: function () {
    // this.path = this.$router.currentRoute.path
    // const control = this.permissions.find(x => x.path === this.path)
    // this.controlPermission = control ? control.permission : []
    this.getAreaInfo(() => {
      this.getDictionary()
      this.getSiteInfo()
      this.getModelInfo()
    })
    
    if (this.user.funcLoader.indexOf('FUNC_CTRL_AI') >= 0) {
        this.MODE_ACtrl = true
    }
  },
  watch: {
    page () {
      this.getPageData()
    },
    "tables.site_share_info.siteSharePage" () {
      this.getSiteShareInfo()
    },
    sitePage () {
      this.getSiteInfo()
    },
    sidebarOpen () {
      if (this.sidebarOpen) {
        this.sidebarWidth = 260
      } else {
        this.sidebarWidth = 70
      }
    },
    searchSiteMNO () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchCustomerId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteName () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteContractId () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    searchSiteByDevice () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    rows () {
      this.page === 1 ? this.getPageData() : this.page = 1
    },
    "tables.site_area_info.page" () {
      this.getSiteAreaInfo()
    },
    "tables.site_area_info.rows" () {
      this.tables.site_area_info.page === 1 ? this.getSiteAreaInfo() : this.tables.site_area_info.page = 1
    },
    "tables.site_share_info.siteShareRows" () {
      this.tables.site_share_info.siteSharePage === 1 ? this.getSiteShareInfo() : this.tables.site_share_info.siteSharePage = 1
    },
    searchSiteDetail () {
      // this.sitePage === 1 ? this.getSiteInfo() : this.sitePage = 1
      this.getSiteInfo()
    },
    "tables.device_info.devicePage" () {
      this.getDeviceInfo()
    },
    "tables.device_location.drawTarget" () {
      this.switchCanvas(this.tables.device_location.drawTarget)
    }
  },
  props: {
    user: null,
    permissions: null,
    isMobile: null
  },
  computed: {
    order () {
      if (this.sortOrder) {
        return 'desc'
      } else {
        return 'asc'
      }
    },
    dialogDeviceInfoTitle () {
      if (this.isEdit) {
        return '編輯設備'
      } else {
        return '新增設備'
      }
    },
    ProtectActivated() {
      return this.BooleanText2YN(this.selectSiteInfo.ProtectActivated)
    }
  },
  methods: {
    showWaiting (isWaiting, msgWaiting) {
      this.$emit('setWaiting', { mWaiting: 0, isWaiting: isWaiting, msgWaiting: msgWaiting })
    },
    showAlert (type, message) {
      var alert = {
        alertType: null,
        alertMessage: '',
        alertIcon: null
      }
      if (type === 'success') {
        alert.alertType = 'success'
        alert.alertIcon = 'mdi-check-circle'
      } else {
        alert.alertType = 'error'
        alert.alertIcon = 'mdi-alert-circle'
      }
      alert.alertMessage = message
      this.$emit('setAlert', alert)
    },
    changeSort (header) {
      if (!header.sortable) return

      if (header.value === this.sortItem) {
        this.sortOrder = !this.sortOrder
      } else {
        this.sortOrder = true
        this.sortItem = header.value
      }
      this.getPageData()
    },
    getDictionary () {
      var parm = ['site_id(withRemoved)', 'area_info', 'allUsers', 'customer_info', 'permission_definition', 'device_info', 'device_type_info', 'account_info']
      Service.getDictionary(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var siteInfoIndex = response.data.map(function (item) { return item.dicNo }).indexOf('site_id(withRemoved)')
            var areaIndex = response.data.map(function (item) { return item.dicNo }).indexOf('area_info')
            var allUsersIndex = response.data.map(function (item) { return item.dicNo }).indexOf('allUsers')
            var customerIndex = response.data.map(function (item) { return item.dicNo }).indexOf('customer_info')
            var accountIndex = response.data.map(function (item) { return item.dicNo }).indexOf('account_info')
            var permissionIndex = response.data.map(function (item) { return item.dicNo }).indexOf('permission_definition')
            var deviceInfoIndex = response.data.map(function (item) { return item.dicNo }).indexOf('device_info')
            var deviceTypeInfoIndex = response.data.map(function (item) { return item.dicNo }).indexOf('device_type_info')
            var siteInfoList = response.data[siteInfoIndex].data
            var areaList = response.data[areaIndex].data
            var allUsersList = response.data[allUsersIndex].data
            var customerList = response.data[customerIndex].data
            var accountList =  response.data[accountIndex].data
            var permissionList = response.data[permissionIndex].data
            var deviceInfoList = response.data[deviceInfoIndex].data
            var deviceTypeList = response.data[deviceTypeInfoIndex].data
            siteInfoList.forEach(element => {
              var deviceType = {
                value: element.key,
                text: element.value
              }
              this.dict.siteInfoList.push(deviceType)
            })
            areaList.forEach(element => {
              var area = {
                value: element.key,
                text: element.key + ' ' +element.value
              }
              this.areaList.push(area)
            })
            allUsersList.forEach(element => {
              var users = {
                value: element.key,
                text: element.value
              }
              this.allUsersList.push(users)
            })
            customerList.forEach(element => {
              var customer = {
                value: element.key,
                text: element.key
              }
              this.customerList.push(customer)
            })
            accountList.forEach(element => {
              var customer = {
                value: element.key,
                text: element.key + ' ' + element.value
              }
              this.accountList.push(customer)
            })
            permissionList.forEach(element => {
              var permission = {
                value: Math.pow(2, element.value),
                text: element.key
              }
              this.permissionList.push(permission)
            })
            deviceInfoList.forEach(element => {
              var device = {
                value: element.key,
                text: element.value
              }
              this.deviceInfoList.push(device)
            })
            deviceTypeList.forEach(element => {
              var deviceType = {
                value: element.key,
                text: element.value
              }
              this.deviceTypeList.push(deviceType)
            })
            this.deviceTypeMap = deviceTypeList.reduce((acc, cur) => {
              acc[cur.key] = cur.value
              return acc
            }, {})
            this.getPageData()
          }
        })
    },
    getPageData () {
      this.isLoading = true
      this.siteList = []
      var searchCustomerId = {
        name: 'customer_id',
        value: this.searchCustomerId,
        displayType: 'like'
      }
      var searchSiteId = {
        name: 'site_id',
        value: this.searchSiteId,
        displayType: '='
      }
      var searchSiteMNO = {
        name: 'site_mno',
        value: this.searchSiteMNO,
        displayType: 'like'
      }
      var searchSiteName = {
        name: 'site_nm',
        value: this.searchSiteName,
        displayType: 'like'
      }
      var searchSiteContractId = {
        name: 'site_contract_id',
        value: this.searchSiteContractId,
        displayType: 'like'
      }
      var searchAreaId = {
        name: 'area_id_filter',
        value: this.area_checked.join(','),
        displayType: 'IN'
      }
      
      var wheres = [searchCustomerId, searchSiteId, searchSiteMNO, searchSiteName, searchSiteContractId, searchAreaId]
      if (this.searchSiteByDevice.length > 0) {
        var searchSiteByDevice = {
          name: 'searchSiteByDevice',
          value: this.searchSiteByDevice,
          displayType: 'like'
        }
        wheres.push(searchSiteByDevice)
      }
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'site_info/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.overview_total = response.data.total
            this.pageCount = Math.ceil(this.overview_total / this.rows)
            this.siteList = response.data.rows
            this.siteList.forEach(element => {
              if(element.ScheduleActivated) {
                element.ScheduleActivated = element.ScheduleActivated.toLowerCase()
              } else {
                element.ScheduleActivated = 'false'
              }
              
              var area = this.areaList.find(x => x.value == element.area_id)
              if (area) {
                element.area_name = area.text
              } 
              var user = this.allUsersList.find(x => x.value === element.LastProtectedUser)
              if (user) {
                element.LastProtectedUser = user.text
              }
            })
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    choseSite (item) {
      this.tables.site_area_info.search.site_id.value = item.site_id
      this.tables.site_share_info.searchSiteShareId = item.site_id
      this.selectSiteInfo = item
      this.tables.site_area_info.page === 1 ? this.getSiteAreaInfo() : this.tables.site_area_info.page = 1
      this.tables.site_share_info.siteSharePage === 1 ? this.getSiteShareInfo() : this.tables.site_share_info.siteSharePage = 1
      // this.getSiteAreaInfo()
      // this.getSiteShareInfo()
    },
    openSiteInfoAdd () {
      this.selectSiteInfo = Object.assign({}, this.tables.site_info.defaultItem);
      this.dialogSiteInfoAdd = true
    },
    getSiteAreaInfo () {
      this.dict.site_area_info = []

      this.tables.site_area_info.data = []
      var searchSiteId = {
        name: 'site_id',
        value: this.tables.site_area_info.search.site_id.value,
        displayType: '='
      }
      var wheres = [searchSiteId]
      var parm = {
        page: this.tables.site_area_info.page,
        rows: this.tables.site_area_info.rows,
        order: this.tables.site_area_info.order,
        sort: this.tables.site_area_info.sortItem,
        wheres: JSON.stringify(wheres),
        url: this.tables.site_area_info.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.tables.site_area_info.total = response.data.total
            this.tables.site_area_info.pageCount = Math.ceil(this.tables.site_area_info.total / this.tables.site_area_info.rows)
            this.tables.site_area_info.data = response.data.rows
            this.tables.site_area_info.data.forEach(element => {
              var user = this.allUsersList.find(x => x.value === element.LastProtectedUser)
              if (user) {
                element.LastProtectedUser = user.text
              }
              this.dict.site_area_info.push({ key: element.AreaID, value: element.AreaName })
            })
          }
        })
    },
    getSiteInfo () {
      this.tables.site_info.siteInfoTableList = []
      this.sitePageCount = 0
      var searchSiteId = {
        name: 'site_id',
        value: this.searchSiteDetail,
        displayType: 'like'
      }
      var searchSiteMno = {
        name: 'site_mno',
        value: this.searchSiteDetail,
        displayType: 'like'
      }
      var searchSiteNm = {
        name: 'site_nm',
        value: this.searchSiteDetail,
        displayType: 'like'
      }
      var searchType = {
        name: 'FUNCTION',
        value: 'account_info',
        displayType: '='
      }
      var wheres = [searchSiteId, searchSiteMno, searchSiteNm, searchType]      
      var parm = {
        page: this.sitePage,
        rows: 10,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'site_info/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.siteTotal = response.data.total
            this.sitePageCount = Math.ceil(this.siteTotal / 10)
            this.tables.site_info.siteInfoTableList = response.data.rows
          }
        })
    },
    getSiteShareInfo () {
      this.isLoading = true
      // 避免觸發取得全部資料
      if(this.tables.site_share_info.searchSiteShareId === '') return;

      this.tables.site_share_info.siteShareInfoList = []
      var searchSiteId = {
        name: 'site_id',
        value: this.tables.site_share_info.searchSiteShareId,
        displayType: '='
      }
      var wheres = [searchSiteId]
      var parm = {
        page: this.tables.site_share_info.siteSharePage,
        rows: this.tables.site_share_info.siteShareRows,
        order: 'asc',
        sort: 'account_id',
        wheres: JSON.stringify(wheres),
        url: 'site_share_info/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.tables.site_share_info.site_share_total = response.data.total
            this.tables.site_share_info.siteSharePageCount = Math.ceil(this.tables.site_share_info.site_share_total / this.tables.site_share_info.siteShareRows)
            this.tables.site_share_info.siteShareInfoList = response.data.rows
            this.tables.site_share_info.siteShareInfoList.forEach(element => {
              var user = this.allUsersList.find(x => x.value === element.account_id)
              if (user) {
                element.account_name = user.text
              }

              element.PermissionType_ext = element.PermissionType & 7
            })
          }
        })
        .finally(() => {
          this.isLoading = false
        })
    },
    exportSiteInfoFile () {
      this.isExporting = true
      var searchCustomerId = {
        name: 'customer_id',
        value: this.searchCustomerId,
        displayType: 'like'
      }
      var searchSiteId = {
        name: 'site_id',
        value: this.searchSiteId,
        displayType: 'like'
      }
      var searchSiteMNO = {
        name: 'site_mno',
        value: this.searchSiteMNO,
        displayType: 'like'
      }
      var searchSiteName = {
        name: 'site_nm',
        value: this.searchSiteName,
        displayType: 'like'
      }
      var searchSiteContractId = {
        name: 'site_contract_id',
        value: this.searchSiteContractId,
        displayType: 'like'
      }
      var searchAreaId = {
        name: 'area_id_filter',
        value: this.area_checked.join(','),
        displayType: 'IN'
      }
      var wheres = [searchCustomerId, searchSiteId, searchSiteMNO, searchSiteName, searchSiteContractId, searchAreaId]
      var parm = {
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'site_info/Export'
      }
      Service.exportFile(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200) {
            this.showAlert('error', response.data.message)
          } else {
            var filename = '標的物設備管理.xlsx'
            var downloadURL = ''
            var binaryData = []
            binaryData.push(response.data)
            downloadURL = URL.createObjectURL(new Blob(binaryData, { type: 'application/octet-stream' }))
            var link = document.createElement('a')
            link.href = downloadURL
            link.setAttribute('download', filename)
            document.body.appendChild(link)
            link.click()
            link = null
          }
        })
      .finally(() => {
        this.isExporting = false
      })
    },
    openSiteInfoView (item) {
      this.isView = true
      this.dialogSiteInfoAdd = true
      this.selectSiteInfo = item
      this.tables.site_area_info.search.site_id.value = item.site_id
      this.getSiteAreaInfo()
      this.getDeviceInfo()
      this.tables.schedule_info.search.site_id.value = item.site_id
      this.getPageDataV2(this.tables.schedule_info)
    },
    closeSiteInfoDialog () {
      this.isEdit = false
      this.isView = false
      this.dialogSiteInfoAdd = false
      this.dialogSiteInfoType ='siteInfo'
      this.tables.device_info.selectHubChannel = 0
      this.tables.device_info.deviceExpanded = []
      this.selectDeviceInfo = Object.assign({}, this.tables.device_info.defaultItem);

      if (this.$refs.newSiteInfoForm) {
        this.$refs.newSiteInfoForm.resetValidation()
        this.selectSiteInfo = Object.assign({}, this.tables.site_info.defaultItem);
      }
      // 暫時特別重取頁面資料
      this.getPageData()
    },
    saveSiteInfo () {
      if (this.$refs.newSiteInfoForm.validate()) {
        // og('test')
        var url = this.isEdit ? '/site_info/update' : '/site_info/Add'
        Service.updateData(this.selectSiteInfo, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.closeSiteInfoDialog()
            }
          })
      }
    },
    deleteSiteInfo (item) {
      var deleteList = []
      deleteList.push(item.site_id)
      const url = '/site_info/del'
      Service.deleteData(deleteList, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', response.data.message)
            this.getPageData()
          }
        })
    },
    openSiteInfoEdit (item) {
      this.isEdit = true
      this.dialogSiteInfoAdd = true
      this.selectSiteInfo = item
      this.tables.site_area_info.search.site_id.value = item.site_id
      this.getSiteAreaInfo()
      this.getDeviceInfo()
    },
    openSiteShareInfoAdd () {
      if (this.tables.site_share_info.searchSiteShareId === undefined || this.tables.site_share_info.searchSiteShareId.length === 0) {
        this.showAlert('error', '請先選擇標的物')
        return;
      }
      this.selectSiteShareInfoItem.site_id = this.tables.site_share_info.searchSiteShareId
      var siteShare = this.dict.siteInfoList.find(x => x.value === this.tables.site_share_info.searchSiteShareId)
      if (siteShare) {
        this.selectSiteShareInfoItem.site_nm = siteShare.text
      }
      this.tables.site_share_info.dialogSiteShareInfoAdd = true
    },
    closeSiteShareInfoDialog () {
      this.tables.site_share_info.dialogSiteShareInfoAdd = false
      if (this.$refs.newPermissionForm) {
        this.$refs.newPermissionForm.resetValidation()
        this.selectSiteShareInfoItem = {
          PermissionExpiredTime: '',
          PermissionType: '',
          PermissionType_ext: 0,
          account_id: '',
          card: null,
          create_dt: '',
          create_user: '',
          role: null,
          site_id: '',
          update_dt: '',
          update_user: ''
        }
      }
    },
    saveSiteShareInfoData () {
      if (this.$refs.newPermissionForm.validate()) {
        this.selectSiteShareInfoItem.PermissionType = (this.selectSiteShareInfoItem.PermissionType & 0b1111111111111000000) | this.selectSiteShareInfoItem.PermissionType_ext
        
        // console.log(this.selectSiteShareInfoItem)
        var url = '/site_share_info/Add'
        Service.updateData(this.selectSiteShareInfoItem, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getSiteShareInfo()
              this.closeSiteShareInfoDialog()
            }
          })
      }
    },
    selectSite (item) {
      this.selectSiteShareInfoItem.site_id = item.site_id
      this.selectSiteShareInfoItem.site_nm = item.site_nm
      this.dialogSiteIdAdd = false
    },
    openSiteShareDeleteDialog (item) {
      this.dialogSiteShareDelete = true
      this.deleteSiteShareItem = {
        site_id: item.site_id,
        account_id: item.account_id,
        account_name: item.account_name
      }
    },
    closeSiteShareDeleteDialog () {
      this.dialogSiteShareDelete = false
      if (this.$refs.deleteSiteShareForm) {
        this.$refs.deleteSiteShareForm.resetValidation()
        this.deleteSiteShareItem = {
          site_id: '',
          account_id: '',
          account_name: ''
        }
      }
    },
    deleteSiteShareInfoData () {
      var url = '/site_share_info/DeleleData'
      let data = {
        site_id: this.deleteSiteShareItem.site_id,
        account_id: this.deleteSiteShareItem.account_id
      }
      Service.updateData(data, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', response.data.message)
            this.getSiteShareInfo()
            this.closeSiteShareDeleteDialog()
          }
        })
    },
    openSiteAreaInfoView (item) {
      this.tables.site_area_detail.dialogView = true
      this.tables.site_area_detail.selectedData.AreaID = item.AreaID
      this.tables.site_area_detail.selectedData.site_id = item.site_id
      this.tables.site_area_detail.selectedData.AreaName = item.AreaName
      // console.log(this.tables.site_area_detail.selectedData)
      this.getSiteAreaDetail()
    },
    getSiteAreaDetail () {
      this.tables.site_area_detail.data = []
      var searchSiteId = {
        name: 'site_id',
        value: this.tables.site_area_detail.selectedData.site_id,
        displayType: '='
      }
      var searchAreaId = {
        name: 'AreaID',
        value: this.tables.site_area_detail.selectedData.AreaID,
        displayType: '='
      }
      var wheres = [searchSiteId, searchAreaId]
      var parm = {
        page: this.tables.site_area_detail.page,
        rows: this.tables.site_area_detail.rows,
        order: this.tables.site_area_detail.order,
        sort: this.tables.site_area_detail.sortItem,
        wheres: JSON.stringify(wheres),
        url: this.tables.site_area_detail.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.tables.site_area_detail.total = response.data.total
            this.tables.site_area_detail.pageCount = Math.ceil(this.tables.site_area_detail.total / this.tables.site_area_detail.rows)
            this.tables.site_area_detail.data = response.data.rows
            this.tables.site_area_detail.data.forEach(element => {
              var device = this.deviceInfoList.find(x => x.value === element.device_id)
              if (device) {
                element.device_nm = device.text
              } else {
                element.device_nm = `未設定名稱, (設備編號：${element.device_id})`
              }          
            })
          }
        })
    },
    closeRePwd () {      
      this.dialogRePwd = false
      if (this.$refs.repwdForm) {
        this.$refs.repwdForm.resetValidation()
        this.selectRePwd.site_mno = ''
      }
    },
    saveRePwd () {
      if (this.$refs.repwdForm.validate()) {
        var url = '/site_info/RePwd'
        Service.updateData(this.selectRePwd, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.closeRePwd()
            }
          })
      }
    },
    getDeviceInfo () {
      this.tables.device_info.deviceList = []
      this.tables.device_info.devicePageCount = 0
      var searchSiteId = {
        name: 'site_id',
        value: this.selectSiteInfo.site_id,
        displayType: '='
      }
      var wheres = [searchSiteId]      
      var parm = {
        page: this.tables.device_info.devicePage,
        rows: this.tables.device_info.deviceRows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: this.tables.device_info.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.tables.device_info.deviceTotal = response.data.total
            this.tables.device_info.devicePageCount = Math.ceil(this.tables.device_info.deviceTotal / this.tables.device_info.deviceRows)
            this.tables.device_info.deviceList = response.data.rows
            this.tables.device_info.deviceList.forEach(element => {
              var deviceType = this.deviceTypeList.find(x => x.value === element.device_type)
              if (deviceType) {
                element.device_type_nm = deviceType.text
              }
            })
          }
        })
    },
    closeDeviceInfoDialog () {
      this.tables.device_info.dialogDeviceInfoAdd = false
      this.tables.device_info.isDeviceEdit = false
      if (this.$refs.newDeviceInfoForm) {
        this.$refs.newDeviceInfoForm.resetValidation()
        this.selectDeviceInfo = Object.assign({}, this.tables.device_info.defaultItem);
      }
      // 暫時特別重取頁面資料
      this.getDeviceInfo()
    },
    openDeviceEdit (item) {
      this.tables.device_info.isDeviceEdit = true
      this.tables.device_info.dialogDeviceInfoAdd = true
      this.selectDeviceInfo = item
    },
    saveDeviceInfo () {
      if (this.$refs.newDeviceInfoForm.validate()) {
        this.selectDeviceInfo.site_id = this.selectSiteInfo.site_id
        var url = this.tables.device_info.isDeviceEdit ? '/device_info/update' : '/device_info/Add'
        Service.updateData(this.selectDeviceInfo, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.closeDeviceInfoDialog()
            }
          })
      }
    },
    deviceRowClick (item) {
      this.selectDeviceInfo = item
      this.tables.device_info.selectHubChannel = 0
      // TODO: determind if show expand
      this.toggleDeviceExpand(item)
    },
    deviceChnClick (item) {
      this.tables.device_info.selectHubChannel = item.channel
    },
    GetLiveViewUrl (type) {
      if (this.selectDeviceInfo.device_id === '') {
        this.showAlert('error', '請先選擇裝置')
        return
      }

      this.showWaiting(true, '等待連線中...')
      Service.GetLiveViewUrl({ device_id : this.selectDeviceInfo.device_id, site_id: this.selectDeviceInfo.site_id })
        .then((response) => {
          this.showWaiting(false, '')
          // console.log(response)

          if (response.status !== 200 || !response.data.status) {
            throw new Error(response.data.message)
          }

          return response.data.data
        })
        .then(data => {
          const { accessType, kind, type: deviceType, para } = data
          const paraList = para.split(';')

          if (paraList[0] === 'N') {
            throw new Error('目前不支援P2P連線')
          }

          if (kind === 'HT') {
            paraList.push(type)
            HuntHelper.SetClearFunction(this)
            HuntHelper.OpenWindow(this, paraList, accessType)
          }

          else if (kind === 'MD' && deviceType === 'AI_HUB') {
             paraList.push(type)
              paraList.push(this.tables.device_info.selectHubChannel) // default channel
              if (type===0) {
                let time = new Date()
                let startTime = new Date()
                startTime = startTime.setMinutes(time.getMinutes() - 3)

                paraList.push(this.getdtformat(startTime))
                paraList.push(this.getdtformat(time))
              }
              MDHelper.SetClearFunction(this)
              MDHelper.OpenWindow(this, paraList, accessType)
          }

          else if (kind === 'SS' && deviceType === 'AI_REC') {
              paraList.push(type)
              paraList.push(this.tables.device_info.selectHubChannel) // default channel
              if (type===0) {
                let time = new Date()
                let startTime = new Date()
                startTime = startTime.setMinutes(time.getMinutes() - 3)

                paraList.push(this.getdtformat(startTime))
                paraList.push(this.getdtformat(time))
              }
              RecHelper.SetClearFunction(this)
              RecHelper.OpenWindow(this, paraList, accessType)
          }

          else {
              paraList.push(type)
              if (type===0) {
                let time = new Date()
                let startTime = new Date()
                startTime = startTime.setMinutes(time.getMinutes() - 1)

                paraList.push(this.getdtformat(startTime))
                paraList.push(this.getdtformat(time))
              }
              // console.log(paraList)
              this.$store.commit('setRouteParam', paraList)
              this.$store.commit('setAccessType', accessType)
              const routeData = this.$router.resolve({name: 'CameraFunc'})
              window.open(routeData.href, 'Shinsoft', 'height=760,width=660,menubar=no,resizable=no,status=no,toolbar=no,location=no,scrollbars=no')
          }
        })
        .catch((error) => {
          this.showAlert('error', error.message)
        })
    },
    getdtformat(date_) {
        date_ = new Date(date_)
        var year = "" + date_.getFullYear()
        var month = date_.getMonth() + 1
        var day = date_.getDate()
        if (month < 10) month = "0" + month
        else month = "" + month
        if (day < 10) day = "0" + day
        else day = "" + day

        var hours = date_.getHours()
        var mins = date_.getMinutes()
        var secs = date_.getSeconds()
        if (hours < 10) hours = "0" + hours
        else hours = "" + hours
        if (mins < 10) mins = "0" + mins
        else mins = "" + mins
        if (secs < 10) secs = "0" + secs
        else secs = "" + secs
        return "" + year + '-' + month + '-' + day + 'T' + hours + ':' + mins + ':' + secs
    },
    getLastEventPic () {
      if (this.selectDeviceInfo.device_id === '') {
        this.showAlert('error', '請先選擇裝置')
        return
      }
      var url = '/site_info/getLastEventPic'
      Service.updateData({ deviceID : this.selectDeviceInfo.device_id, deviceChn: this.tables.device_info.selectHubChannel, deviceModel: this.selectDeviceInfo.device_model }, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              // this.showAlert('success', response.data.message)
              // console.log(response.data.data)
              if (response.data.data !== 'N') {
                this.tables.device_location.dialogDeviceLocation = true
                this.tables.device_location.image = "url(data:tables.device_location.image/png;base64," + response.data.data + ")"
                this.setShade()
              } else {
                this.showAlert('error', '未搜尋到設備圖片')
              }
            }
          })
    },
    setShade () {
      this.$nextTick(() => {
        this.tables.device_location.can = document.getElementById("canvas")
        this.tables.device_location.canSave = document.getElementById("canvasSave")
        this.tables.device_location.scan = document.getElementById("Scanvas")
        this.tables.device_location.lcan = document.getElementById("Lcanvas")
        this.tables.device_location.ctx = this.tables.device_location.can.getContext('2d')
        this.tables.device_location.ctxSave = this.tables.device_location.canSave.getContext('2d')
        this.tables.device_location.sctx = this.tables.device_location.scan.getContext('2d')
        this.tables.device_location.lctx = this.tables.device_location.lcan.getContext('2d')

        this.tables.device_location.ctx.strokeStyle = this.tables.device_location.DefaultEdgeStyle//線条颜色
        this.tables.device_location.ctx.lineWidth = this.tables.device_location.LineWidth
        this.tables.device_location.ctx.globalAlpha = this.tables.device_location.GlobalAlpha
        this.tables.device_location.ctxSave.strokeStyle = this.tables.device_location.DefaultEdgeStyle//線条颜色
        this.tables.device_location.ctxSave.lineWidth = this.tables.device_location.LineWidth
        this.tables.device_location.ctxSave.globalAlpha = this.tables.device_location.GlobalAlpha

        this.tables.device_location.sctx.clearRect(0, 0, this.tables.device_location.lcan.width, this.tables.device_location.lcan.height)
        this.tables.device_location.lctx.clearRect(0, 0, this.tables.device_location.lcan.width, this.tables.device_location.lcan.height)
        // this.clearLocation()
      })

      this.dialogs.ai_location_name = (this.dialogs.const_model_thremal == this.selectDeviceInfo.device_model) 
        ? this.dialogs.const_thermal_ai_name
        : this.dialogs.const_camera__ai_name
      this.dialogs.di_location_name = (this.dialogs.const_model_thremal == this.selectDeviceInfo.device_model) 
        ? this.dialogs.const_thermal_di_name
        : this.dialogs.const_camera__di_name


      if (this.tables.device_info.selectHubChannel == 0) {
        this.tables.device_location.target        = Object.assign({}, this.selectDeviceInfo);
      }
      else {
        let target = this.selectDeviceInfo.subdevice.filter(o=>o.channel === this.tables.device_info.selectHubChannel)[0]
        this.tables.device_location.target        = target;
      }
      this.tables.device_location.default_ai    = this.tables.device_location.target.device_ai_location
      this.tables.device_location.default_di    = this.tables.device_location.target.device_di_location
      this.tables.device_location.default_model = this.tables.device_location.target.ai_model
      this.tables.device_location.default_param = this.tables.device_location.target.ai_param


      this.tables.device_location.drawTarget = 'L'
      this.switchCanvas('L')
    },
    switchCanvas (type) {
      
      // console.log(type)
      // console.log(this.selectDeviceInfo.device_id, this.tables.device_info.selectHubChannel)
      this.tables.device_location.selectedRegion = {}
      this.tables.device_location.paintstatu = type
      
      this.$nextTick(() => {
        if (this.MODE_ACtrl) {
          document.getElementById("ATool").style.display = "display"
        }
        else {
          document.getElementById("ATool").style.display = "none"
        }
      })
      // 遮蔽區
      var shadeSet = []
      if (this.tables.device_location.target.device_di_location != "" && this.tables.device_location.target.device_di_location != null) {
        shadeSet = this.parseFormat(this.tables.device_location.target.device_di_location)
        // console.log(shadeSet)
        this.$nextTick(() => {
          this.drawCanvas(this.tables.device_location.sctx, this.tables.device_location.scan, shadeSet, 'S')
        })        
      }
      else {
        this.makeRegionList([], 'S')
        this.$nextTick(() => {
          this.tables.device_location.sctx.clearRect(0, 0, this.tables.device_location.scan.width, this.tables.device_location.scan.height)
        })
      }
      // 偵測區
      var locationSet = []
      // 修正熱成像 不顯示 ai 
      if (this.dialogs.const_model_thremal === this.tables.device_location.target.device_model) {
        this.makeRegionList([], 'L')
        this.$nextTick(() => {
          this.tables.device_location.lctx.clearRect(0, 0, this.tables.device_location.lcan.width, this.tables.device_location.lcan.height)
        })
      }
      else if (this.tables.device_location.target.device_ai_location != "" && this.tables.device_location.target.device_ai_location != null) {
        locationSet = this.parseFormat(this.tables.device_location.target.device_ai_location)
        // console.log(locationSet)
        this.$nextTick(() => {
          this.drawCanvas(this.tables.device_location.lctx, this.tables.device_location.lcan, locationSet, 'L')
        })       
      }
      else {
        this.makeRegionList([], 'L')
        this.$nextTick(() => {
          this.tables.device_location.lctx.clearRect(0, 0, this.tables.device_location.lcan.width, this.tables.device_location.lcan.height)
        })
      }
      // 操作區
      this.clearLocation();

      if (this.tables.device_location.paintstatu == 'S') {
        this.tables.device_location.regionSet = shadeSet;
      }
      else {
        this.tables.device_location.regionSet = locationSet;
      }
      // console.log(this.tables.device_location.regionSet)
    },
    clearLocation () {
      this.$nextTick(() => {
        this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height)
        this.tables.device_location.ctxSave.clearRect(0, 0, this.tables.device_location.canSave.width, this.tables.device_location.canSave.height)
      })  
      this.tables.device_location.regionSet = []
      this.ointArr = []
    },
    parseFormat(data) {
      var rs = []
      var splitarea = data.split('$')
      for (var j = 0; j < splitarea.length; j++) {
        var splitdata = splitarea[j].split('@')
        var splitpoint = ""

        var subRegion = []
        for (var i = 1; i < splitdata.length; i++) {
          splitpoint = splitdata[i].split('#')
          var piX = splitpoint[0]
          var piY = splitpoint[1]
          subRegion.push({
              x: piX, y: piY
          })
        }
        rs.push(subRegion)
      }
      return rs
    },
    formFormat (regionSet, type) {
      var tmpstr = ""
      for (var index = 0; index < regionSet.length; ++index) {
        var subRegion = regionSet[index]

        if (index == 0) tmpstr += subRegion.length
        else tmpstr += "$" + subRegion.length

        for (var i = 0; i < subRegion.length; i++) {
          tmpstr += "@" + parseInt(subRegion[i].x) + "#" + parseInt(subRegion[i].y)
        }
      }

      if (type === 'S') {
        // this.tables.device_location.default_di = tmpstr
        this.tables.device_location.target.device_di_location = tmpstr
      }
      else {
        // this.tables.device_location.default_ai = tmpstr
        this.tables.device_location.target.device_ai_location = tmpstr
      }
    },
    drawCanvas(context, canvas, dataSet, type, hl_index, hl_type) {
      // console.log(dataSet)
      // console.log(hl_type + ' - ' + hl_index)
      context.clearRect(0, 0, canvas.width, canvas.height)

      var edge = this.tables.device_location.LocationEdgeStyle
      var fill = this.tables.device_location.LocationFillStyle
      if (type === 'S') {
        edge = this.tables.device_location.ShadeEdgeStyle
        fill = this.tables.device_location.ShadeFillStyle
      }
      context.strokeStyle = edge//線条颜色
      context.fillStyle   = fill//填充颜色
      context.lineWidth   = this.tables.device_location.LineWidth//線条粗细
      context.globalAlpha = this.tables.device_location.GlobalAlpha

      if (type === this.tables.device_location.paintstatu) {
        // console.log('test')
        this.makeRegionList(dataSet, type)
        // this.$nextTick (() => {
        //   this.makeRegionList(dataSet, type)
        // })
      }

      context.clearRect(0, 0, canvas.width, canvas.height)
      for (var index = 0; index < dataSet.length; ++index) {

        if (hl_type && hl_index === index) {
          // 標記選擇內框色
          context.fillStyle   = this.tables.device_location.SelectedEdgeStyle
          context.strokeStyle = this.tables.device_location.SelectedFillStyle
        }
        else {
          context.fillStyle   = fill
          context.strokeStyle = edge
        }
        context.beginPath();

        var subRegion = dataSet[index]
        // console.log(subRegion)
        context.moveTo(subRegion[0].x, subRegion[0].y)
        for (var i = 1; i < subRegion.length; i++) {
          context.lineTo(subRegion[i].x, subRegion[i].y)
        }

        context.closePath()
        context.fill()
        context.stroke()//繪製
      }

      this.tables.device_location.pointArr = []
      // console.log(this.tables.device_location.regionSet)
    },
    makeRegionList(dataSet) {
      this.tables.device_location.regionList = dataSet
    },
    selectRegion(type, index) {
      // console.log('selectRegion')
      // console.log(type)
      // console.log(index)
      // console.log(this.tables.device_location.regionSet)
      this.tables.device_location.selectedRegion.type = type;
      this.tables.device_location.selectedRegion.index = index;

      if (type === 'S') {
        this.drawCanvas(this.tables.device_location.sctx, this.tables.device_location.scan, this.tables.device_location.regionSet, 'S', index, 'S');
      }
      else {
        this.drawCanvas(this.tables.device_location.lctx, this.tables.device_location.lcan, this.tables.device_location.regionSet, 'L', index, 'L');
      }
    },
    removeRegion() {
      if (this.tables.device_location.selectedRegion.type && this.tables.device_location.selectedRegion.type === this.tables.device_location.paintstatu) {
        this.tables.device_location.regionSet.splice(this.tables.device_location.selectedRegion.index, 1)
        this.tables.device_location.selectedRegion = {}
        this.formFormat(this.tables.device_location.regionSet, this.tables.device_location.paintstatu)
        if (this.tables.device_location.paintstatu === 'S') {
          this.drawCanvas(this.tables.device_location.sctx, this.tables.device_location.scan, this.tables.device_location.regionSet, 'S')
        }
        else {
          this.drawCanvas(this.tables.device_location.lctx, this.tables.device_location.lcan, this.tables.device_location.regionSet, 'L')
        }
      }
      else {
        this.tables.device_location.selectedRegion = {}
      }
    },
    mouseClick (e) {
      if (e.offsetX || e.layerX) {
        var max = 1
        if (this.tables.device_location.paintstatu === 'L') {
          max = 1
        }
        else {
          if (this.dialogs.const_model_thremal == this.tables.device_location.target.device_model) {
            max = 1
          } 
          else if (this.MODE_ACtrl) {
            max = -1
          }
          else {
            max = 1
          }
        }
        if (this.tables.device_location.regionSet.length == max) {
          return;
        }
        this.tables.device_location.pointX = e.offsetX == undefined ? e.layerX : e.offsetX
        this.tables.device_location.pointY = e.offsetY == undefined ? e.layerY : e.offsetY
        var piX, piY;
        if (this.tables.device_location.oIndex > 0 && this.tables.device_location.pointArr.length > 0) {
            // 結尾
          piX = this.tables.device_location.pointArr[0].x
          piY = this.tables.device_location.pointArr[0].y
          //画點
          //makearc(tables.device_location.ctx, piX, piY, GetRandomNum(2, 2), 0, 180, tables.device_location.DefaultEdgeStyle);
          this.tables.device_location.pointArr.push({
              x: piX, y: piY
          });

          this.tables.device_location.regionSet.push(this.tables.device_location.pointArr)
          this.makeRegionList(this.tables.device_location.regionSet, this.tables.device_location.paintstatu)

          this.formFormat(this.tables.device_location.regionSet, this.tables.device_location.paintstatu)
          if (this.tables.device_location.paintstatu === 'S') {
            this.drawCanvas(this.tables.device_location.sctx, this.tables.device_location.scan, this.tables.device_location.regionSet, 'S')
          }
          else {
            this.drawCanvas(this.tables.device_location.lctx, this.tables.device_location.lcan, this.tables.device_location.regionSet, 'L')
          }

          this.tables.device_location.pointArr = []
          this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height)
          this.tables.device_location.ctxSave.clearRect(0, 0, this.tables.device_location.canSave.width, this.tables.device_location.canSave.height)
        } else {
          // 產生中間點
          piX = this.tables.device_location.pointX
          piY = this.tables.device_location.pointY
          this.makearc(this.tables.device_location.ctx, piX, piY, this.GetRandomNum(2, 2), 0, 180, this.tables.device_location.DefaultEdgeStyle)
          this.tables.device_location.pointArr.push({
              x: piX, y: piY
          })
          this.canvasSave(this.tables.device_location.pointArr);//保存點線同步到另一个canvas

          if (this.tables.device_location.pointArr.length == 8) { //最多8點
            piX = this.tables.device_location.pointArr[0].x
            piY = this.tables.device_location.pointArr[0].y
            //画點
            //makearc(tables.device_location.ctx, piX, piY, GetRandomNum(2, 2), 0, 180, tables.device_location.DefaultEdgeStyle);
            this.tables.device_location.pointArr.push({
                x: piX, y: piY
            });
            this.tables.device_location.regionSet.push(this.tables.device_location.pointArr)
            this.makeRegionList(this.tables.device_location.regionSet, this.tables.device_location.paintstatu)

            this.formFormat(this.tables.device_location.regionSet, this.tables.device_location.paintstatu)
            if (this.tables.device_location.paintstatu === 'S') {
              this.drawCanvas(this.tables.device_location.sctx, this.tables.device_location.scan, this.tables.device_location.regionSet, 'S')
            }
            else {
              this.drawCanvas(this.tables.device_location.lctx, this.tables.device_location.lcan, this.tables.device_location.regionSet, 'L')
            }

            this.tables.device_location.pointArr = []
            this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height)
            this.tables.device_location.ctxSave.clearRect(0, 0, this.tables.device_location.canSave.width, this.tables.device_location.canSave.height)
          }
        }
      }
    },
    mouseMove (e) {
      if (e.offsetX || e.layerX) {
        this.tables.device_location.pointX = e.offsetX == undefined ? e.layerX : e.offsetX;
        this.tables.device_location.pointY = e.offsetY == undefined ? e.layerY : e.offsetY;
        var piX, piY;
        /*清空画布*/
        this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height);
        /*鼠标下跟随的圆點*/
        this.makearc(this.tables.device_location.ctx, this.tables.device_location.pointX, this.tables.device_location.pointY, this.GetRandomNum(4, 4), 0, 180, this.tables.device_location.DefaultEdgeStyle);

        if (this.tables.device_location.pointArr.length > 0) {
          if ((this.tables.device_location.pointX > this.tables.device_location.pointArr[0].x - 15 && this.tables.device_location.pointX < this.tables.device_location.pointArr[0].x + 15) && (this.tables.device_location.pointY > this.tables.device_location.pointArr[0].y - 15 && this.tables.device_location.pointY < this.tables.device_location.pointArr[0].y + 15)) {
            if (this.tables.device_location.pointArr.length > 1) {

              piX = this.tables.device_location.pointArr[0].x;
              piY = this.tables.device_location.pointArr[0].y;
              this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height);
              this.makearc(this.tables.device_location.ctx, piX, piY, this.GetRandomNum(4, 4), 0, 180, this.tables.device_location.DefaultEdgeStyle);
              this.tables.device_location.oIndex = 1;
            }
          } else {
            piX = this.tables.device_location.pointX;
            piY = this.tables.device_location.pointY;
            this.tables.device_location.oIndex = -1;
          }
            /*開始繪製*/
          this.tables.device_location.ctx.beginPath();
          this.tables.device_location.ctx.moveTo(this.tables.device_location.pointArr[0].x, this.tables.device_location.pointArr[0].y);
          if (this.tables.device_location.pointArr.length > 1) {
            for (var i = 1; i < this.tables.device_location.pointArr.length; i++) {
              this.tables.device_location.ctx.lineTo(this.tables.device_location.pointArr[i].x, this.tables.device_location.pointArr[i].y);
            }
          }
          this.tables.device_location.ctx.lineTo(piX, piY);
          this.tables.device_location.ctx.fillStyle = this.tables.device_location.DefaultFillStyle;//填充颜色
          this.tables.device_location.ctx.fill();//填充
          this.tables.device_location.ctx.stroke();//繪製
        }
      }
    },
    // 存储已生成的點線
    canvasSave(pointArr) {
      this.tables.device_location.ctxSave.clearRect(0, 0, this.tables.device_location.ctxSave.width, this.tables.device_location.ctxSave.height);
      this.tables.device_location.ctxSave.beginPath();
      if (pointArr.length > 1) {
        this.tables.device_location.ctxSave.moveTo(pointArr[0].x, pointArr[0].y);
        for (var i = 1; i < pointArr.length; i++) {

          this.tables.device_location.ctxSave.lineTo(pointArr[i].x, pointArr[i].y);
          this.tables.device_location.ctxSave.fillStyle = this.tables.device_location.DefaultFillStyle;//填充颜色
          //tables.device_location.ctxSave.fill();
          this.tables.device_location.ctxSave.stroke();//繪製
        }
        this.tables.device_location.ctxSave.closePath();
      }
    },
    /*生成画布 結束绘画*/
    saveCanvas() {
      this.tables.device_location.ctx.clearRect(0, 0, this.tables.device_location.can.width, this.tables.device_location.can.height);
      this.tables.device_location.ctxSave.closePath();//結束路徑狀態，結束當前路徑，如果是一个未封闭的圖形，會自動將首尾相連封闭起来
      this.tables.device_location.ctxSave.fill();//填充
      this.tables.device_location.ctxSave.stroke();//繪製
      this.tables.device_location.pointArr = [];
    },
    /*验证canvas画布是否為空函數*/
    isCanvasBlank(canvas) {
      var blank = document.createElement('canvas');//创建一个空canvas对象
      blank.width = canvas.width;
      blank.height = canvas.height;
      return canvas.toDataURL() == blank.toDataURL();//為空 返回true
    },
    /*canvas生成圆點*/
    GetRandomNum(Min, Max) {
      var Range = Max - Min;
      var Rand = Math.random();
      return (Min + Math.round(Rand * Range));
    },
    makearc(ctx, x, y, r, s, e, color) {
      ctx.clearRect(0, 0, 199, 202);//清空画布
      ctx.beginPath();
      ctx.fillStyle = color;
      ctx.arc(x, y, r, s, e);
      ctx.fill();
    },
    closeDialogDeviceLocation () {
      this.tables.device_location.dialogDeviceLocation = false
      this.tables.device_location.default_model = 'model_v2'
      this.tables.device_location.default_param = '0.5'
    },
    resetLocation () {
      // console.log(this.tables.device_location.default_di)
      this.tables.device_location.target.device_ai_location = this.tables.device_location.default_ai
      this.tables.device_location.target.device_di_location = this.tables.device_location.default_di
      this.tables.device_location.target.ai_model = this.tables.device_location.default_model
      this.tables.device_location.target.ai_param = this.tables.device_location.default_param
      this.tables.device_location.drawTarget = 'L'
      this.switchCanvas('L')
    },
    saveDeviceLocation () {
      var url = '/device_info/SaveALLLocation'
      
      // 修正熱成像 device_ai_location, device_di_location 為相同的值
      if (this.dialogs.const_model_thremal === this.tables.device_location.target.device_model) {
        this.tables.device_location.target.device_ai_location = this.tables.device_location.target.device_di_location
      }
      Service.updateData(this.tables.device_location.target, url)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || !response.data.status) {
            this.showAlert('error', response.data.message)
          } else {
            this.showAlert('success', response.data.message)
            this.getDeviceInfo()
            this.closeDialogDeviceLocation()
          }
        })
    },
    getModelInfo () {
      this.modelInfoList = []
      var wheres = []      
      var parm = {
        page: this.sitePage,
        rows: 10,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'model_info/getPageData'
      }
      Service.getPageData(parm, true)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            response.data.rows.forEach(element => {
              var model = {
                id: element.SeqNo,
                text: element.model_name,
                value: element.model_name
              }
              this.modelInfoList.push(model)
            })
            // console.log(this.modelInfoList)
          }
        })
    },
    closeDialogModelAdd () {
      this.dialogModelAdd = false
      if (this.$refs.newModelInfoForm) {
        this.$refs.newModelInfoForm.resetValidation()
        this.selectModel = {
          model_name: ''
        }
      }
    },
    AddModel () {
      if (this.$refs.newModelInfoForm.validate()) {
        var url = '/model_info/Add'
        Service.updateData(this.selectModel, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getModelInfo()
              this.closeDialogModelAdd()
            }
          })
      }
    },
    deleteModel () {
      if (this.modelInfoList.length === 1) {
        this.showAlert('error', '模型列表不足無法刪除')
        return
      }
      var model = this.modelInfoList.find(x => x.text === this.tables.device_location.target.ai_model)
      if (model) {
        var deleteList = []
        deleteList.push(model.id)
        const url = '/model_info/del'
        Service.deleteData(deleteList, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getModelInfo()
              this.tables.device_location.target.ai_model = 'model_v2'
              this.dialogModelDelete = false
            }
          })
      }else {
        this.showAlert('error', '無法刪除')
      }
    },
    openDeviceDeleteDialog (item) {
      this.tables.device_info.dialogDeviceDelete = true
      this.selectDeviceInfo = item
    },
    closeDeviceDeleteDialog () {
      this.tables.device_info.dialogDeviceDelete = false
      if (this.$refs.deleteDeviceForm) {
        this.$refs.deleteDeviceForm.resetValidation()
      }
    },
    deleteDevice () {
      if (this.$refs.deleteDeviceForm) {
        this.$refs.deleteDeviceForm.resetValidation()
        
        const url = '/device_info/del_custom'
        Service.updateData(this.selectDeviceInfo, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getDeviceInfo()
              this.selectDeviceInfo = Object.assign({}, this.tables.device_info.defaultItem);
              this.tables.device_info.dialogDeviceDelete = false
            }
          })
      }
    },
    openSiteDeleteDialog (item) {
      this.dialogSiteDelete = true
      this.deleteSiteItem = {
        site_id: item.site_id,
        site_mno: item.site_mno,
        site_nm: item.site_nm,
        area_id: item.area_id,
        customer_id: item.customer_id
      }
    },
    closeSiteDeleteDialog () {
      this.dialogSiteDelete = false
      if (this.$refs.deleteSiteForm) {
        this.$refs.deleteSiteForm.resetValidation()
      }

      this.deleteSiteItem = {
        site_id: '',
        site_mno: '',
        site_nm: '',
        area_id: '',
        customer_id: '',
      }
    },
    deleteSite () {
      if (this.$refs.deleteSiteForm) {
        this.$refs.deleteSiteForm.resetValidation()
        
        const url = '/site_info/del_custom'
        Service.updateData(this.deleteSiteItem, url)
          .then((response) => {
            // console.log(response)
            if (response.status !== 200 || !response.data.status) {
              this.showAlert('error', response.data.message)
            } else {
              this.showAlert('success', response.data.message)
              this.getPageData()
              this.dialogSiteDelete = false
            }
          })
      }
    },
    IntText2YN (value) {
      if(value === null || value === '') {
        return '未設定'
      }
      else if(value === 0) {
        return 'N'
      }
      else if(value === '0') {
        return 'N'
      }
      return 'Y'
    },
    BooleanText2YN (value) {
      if(value === null || value === '') {
        return '未設定'
      }
      else if(value.toLowerCase() === 'false') {
        return 'N'
      }
      return 'Y'
    },
    Dictionary2Text(dict, value) {
      var target = dict.find(o=>o.key == value)
      if (target) { return target.value }
      return ''
    },
    PermissionType2Text (pt) {
      var item = this.permissionList.find(item=> item.value === pt);
      if (item) {
        return item.text
      }
      return pt
    },
    getAreaInfo(callback) {
      this.areaList = []
      var wheres = []
      var parm = {
        page: this.page,
        rows: this.rows,
        order: this.order,
        sort: this.sortItem,
        wheres: JSON.stringify(wheres),
        url: 'area_info/getPageData'
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            this.areaListFilter = response.data.rows
            // 版面調整
            if(this.areaListFilter.length < 8) {
              for(var idx = this.areaListFilter.length; idx < 8; idx+=1) {
                //this.areaListFilter.push({area_id:'DUMMY'+idx, area_nm: ''})
              }
            }

            this.area_checked = []
            this.areaListFilter.forEach(area => {
              this.area_checked.push(area.area_id)
            })
            
            if (callback) callback()
          }
        })
    },
    // 簡易輸入防抖機制
    tryGetRealTimeAlertPageData () {
      if (this.area_checked_timer) {
        clearTimeout(this.area_checked_timer)
      }

      this.area_checked_timer = setTimeout(() => {
        // get data
        this.getPageData() 
      }, 500)
    },
    device_unlock() {
      if (this.device_function_area.device_id.length > 0) {
        var yes = confirm(`是否確定解綁設備編號：${this.device_function_area.device_id}`);
        if (yes) {
          const url = '/all_device_info/DeviceUnlock'
          Service.updateData({ device_id: this.device_function_area.device_id }, url)
            .then((response) => {
              // console.log(response)
              if (response.status !== 200 || !response.data.status) {
                this.showAlert('error', response.data.message)
              } else {
                this.showAlert('success', response.data.message)
              }
            })
        }
      } else {
        this.showAlert('error', '請輸入設備編號')
      }
    },

    getPageDataV2 (table) {
      table.isLoading = true
      table.pageCount = 0
      table.data = []
      var wheres = []
      
      for (var variable in table.search) {
        wheres.push(table.search[variable])
      }
      var parm = {
        page: table.page,
        rows: table.rows,
        order: table.sortOrder ? 'desc' : 'asc',
        sort: table.sortItem,
        wheres: JSON.stringify(wheres),
        url: table.urlGet
      }
      Service.getPageData(parm)
        .then((response) => {
          // console.log(response)
          if (response.status !== 200 || response.data.status !== 0) {
            this.showAlert('error', response.data.message)
          } else {
            table.total = response.data.total
            table.pageCount = Math.ceil(table.total / table.rows)
            table.data = response.data.rows
            // console.log(table.data)
          }
        })
      .finally(() => {
        table.isLoading = false
      })
    },
    toggleDeviceExpand(item) {
      const index = this.tables.device_info.deviceExpanded.indexOf(item);

      if (index > -1) {
        this.tables.device_info.deviceExpanded = []
      } else {
        this.tables.device_info.deviceExpanded = [item]
      }
    },
    isDeviceExpanded(item) {
      return this.tables.device_info.deviceExpanded.includes(item)
    }
  }
}
</script>

<style scoped>
.device-table tr {
  background-color: #FFF;
}

.device-table tr.isOdd {
  background-color: #EEF7FF
}

.device-table tr.expanedDeviceRow {
  background-color: #fce3e7;
}

.device-table tr.expanedDeviceRow.isOdd {
  background-color: #ffd4db
}

.device-table tr.expanedDeviceRow:hover {
  background-color: #ffc9d2 !important;
}
.device-table tr.selectedRow.expandedDeviceRow {
  color: red;
}
.device-table tr.selectedChannel {
  color: red;
}
</style>
